import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { useLocation } from "@/lib/router-compat";

type Language = "zh" | "en" | "th";

interface LanguageContextType {
 language: Language;
 setLanguage: (lang: Language) => void;
 t: (key: string) => string;
}

const translations: Record<Language, Record<string, string>> = {
 zh: {
 // Navbar
    "nav.home": "首页",
    "nav.solutions": "解决方案",
    "nav.digitalWorkers": "AI Agent",
    "nav.cases": "客户案例",
    "nav.about": "关于我们",
    "nav.faq": "常见问题",
    "nav.consult": "联系我们",
    "nav.faq.whatIs": "什么是 CargoNova",
    "nav.faq.compare": "CargoNova vs CargoWise",
    "nav.faq.aiAgents": "AI Agent",
    "nav.faq.pricing": "价格计费",
    "nav.faq.implementation": "实施迁移",
    "nav.brand": "智航",
    "nav.brandHighlight": "物流",
 // Hero
 "hero.badge": "端到端 AI 驱动",
 "hero.title1": "AI Native + AI Agents, ",
 "hero.title2": "重塑货代效率新边界",
 "hero.title3": "",
 "hero.desc": "CargoNova AI — Deep Insights 旗下 AI 原生货代系统，以 AI 重新定义端到端国际物流",
 "hero.cta1": "立即体验",
 "hero.cta2": "观看演示",
 "hero.stat1Value": "99.5%",
 "hero.stat1Label": "运价 SLA",
 "hero.stat2Value": "98.2%",
 "hero.stat2Label": "订舱成功率",
 "hero.stat3Value": "99.8%",
 "hero.stat3Label": "单证准确率",
 // Services Section
 "services.badge": "核心优势",
 "services.title": "为何选择 CargoNova",
 "services.desc": "为国际货代的未来而生",
 "services.shipping.title": "AI 原生 + 云原生双基因",
 "services.shipping.desc": "从底层架构开始就以 AI 为核心设计，非后期改造。真正的云原生架构确保无限扩展和零运维。",
 "services.shipping.f1": "AI 核心设计",
 "services.shipping.f2": "无限扩展",
 "services.shipping.f3": "零运维",
 "services.air.title": "AI Agent 矩阵",
 "services.air.desc": "多个专业 AI Agent 无缝协作，处理运价、订舱、单证和关务，覆盖您的整个运营链路。",
 "services.air.f1": "运价查询",
 "services.air.f2": "订舱单证",
 "services.air.f3": "关务处理",
 "services.pricing.title": "全球化就绪",
 "services.pricing.desc": "内置多语言、多币种、多法规支持。从第一天起就能本地化合规地部署全球业务。",
 "services.pricing.f1": "多语言",
 "services.pricing.f2": "多币种",
 "services.pricing.f3": "多法规",
 "services.settlement.title": "上下游无缝集成",
 "services.settlement.desc": "看-算-写闭环自动化。无需 API 即可对接任何老旧系统。AI Agent 无缝衔接新老系统。",
 "services.settlement.f1": "闭环自动化",
 "services.settlement.f2": "无需 API",
    "services.settlement.f3": "新老系统衔接",
    "services.learnMore": "探索解决方案",
    "services.compareLink": "CargoNova vs CargoWise",
    // AI Agent Showcase
 "digitalWorker.badge": "AI Agent",
 "digitalWorker.title": "您的专属 AI Agent 团队",
 "digitalWorker.desc": "老板，您不是买了一套系统，而是雇佣了 7 位金牌员工",
 // Module Showcase - NovaQuote
    "module.quote.title": "NovaSales",
 "module.quote.subtitle": "多维报价师",
 "module.quote.f1": "2分钟报价",
 "module.quote.f2": "多维对比",
 "module.quote.f3": "智能推荐",
 "module.quote.d1": "自动解析客户询价",
 "module.quote.d2": "多船司价格对比",
 "module.quote.d3": "毛利智能优化",
 "module.quote.d4": "报价单一键生成",
 // Module Showcase - NovaRate
 "module.rate.title": "NovaRate",
 "module.rate.subtitle": "航价智算官",
 "module.rate.f1": "合约解析",
 "module.rate.f2": "价格索引",
 "module.rate.f3": "SLA监控",
 "module.rate.d1": "合约价自动解析",
 "module.rate.d2": "市场价实时聚合",
 "module.rate.d3": "智能报价策略",
 "module.rate.d4": "运价SLA预警",
 // Module Showcase - NovaBook
 "module.book.title": "NovaBook",
 "module.book.subtitle": "订舱调度官",
 "module.book.f1": "直连船司",
 "module.book.f2": "容量预测",
 "module.book.f3": "异常处理",
 "module.book.d1": "船司API直连",
 "module.book.d2": "数字货代对接",
 "module.book.d3": "舱位智能预测",
 "module.book.d4": "异常自动处理",
 // Module Showcase - NovaDocs
 "module.docs.title": "NovaDocs",
 "module.docs.subtitle": "单证工厂主管",
 "module.docs.f1": "OCR识别",
 "module.docs.f2": "模板学习",
 "module.docs.f3": "FMS同步",
 "module.docs.d1": "OCR+LLM智能识别",
 "module.docs.d2": "模板自学习",
 "module.docs.d3": "异常自动检测",
 "module.docs.d4": "FMS一键同步",
 // Module Showcase - NovaCustoms
 "module.customs.title": "NovaCustoms",
 "module.customs.subtitle": "合规风控顾问",
 "module.customs.f1": "HS编码",
 "module.customs.f2": "制裁筛查",
 "module.customs.f3": "法规图谱",
 "module.customs.d1": "AI推荐HS编码",
 "module.customs.d2": "制裁清单实时筛查",
 "module.customs.d3": "各关区法规知识图谱",
 "module.customs.d4": "自动化合规检查",
 // Module Showcase - NovaFinance
 "module.finance.title": "NovaFinance",
 "module.finance.subtitle": "结算稽核官",
 "module.finance.f1": "自动对账",
 "module.finance.f2": "智能催款",
 "module.finance.f3": "DSO优化",
 "module.finance.d1": "账单自动核对",
 "module.finance.d2": "差异智能标记",
 "module.finance.d3": "催款流程自动化",
 "module.finance.d4": "DSO周期优化",
 // Module Showcase - NovaRisk
 "module.risk.title": "NovaRisk",
 "module.risk.subtitle": "审计风控官",
 "module.risk.f1": "全链路监控",
 "module.risk.f2": "风险预警",
 "module.risk.f3": "智能评分",
 "module.risk.d1": "业务全链路监控",
 "module.risk.d2": "风险实时预警",
 "module.risk.d3": "智能风险评分",
 "module.risk.d4": "合规审计报告",
 // Module Demo Animations
 "demo.quote.agent": "小智·运价专员",
 "demo.quote.request": "上海-洛杉矶海运费报价",
 "demo.quote.task1": "获取最新运价...",
 "demo.quote.task2": "计算附加费用...",
 "demo.quote.task3": "分析客户偏好...",
 "demo.quote.task4": "生成报价单...",
 "demo.quote.savedTime": "节省时间",
 "demo.quote.priceTrend": "报价趋势",
 "demo.quote.accuracy": "准确率",
 "demo.quote.complete": "分析完成",
 "demo.quote.recommend": "推荐",
 "demo.rate.agent": "小智·航价专员",
 "demo.rate.request": "查询 SHA → LAX 最优运价方案",
 "demo.rate.task1": "正在采集多平台运价...",
 "demo.rate.task2": "分析历史价格趋势...",
 "demo.rate.task3": "评估运力与时效...",
 "demo.rate.task4": "生成最优方案...",
 "demo.rate.savedTime": "节省时间",
 "demo.rate.priceTrend": "报价趋势",
 "demo.rate.accuracy": "报价准确率",
 "demo.rate.margin": "毛利优化",
 "demo.rate.complete": "最优方案已生成",
 "demo.rate.result": "船期",
 "demo.book.agent": "小智·订舱专员",
 "demo.book.request": "需要订舱：SHA → LAX, 2x40GP",
 "demo.book.reply1": "已匹配3个舱位，推荐MSC船期5/20",
 "demo.book.confirm": "确认MSC",
 "demo.book.reply2": "订舱成功！舱位号：MSC2024520A",
 "demo.book.successRate": "订舱成功率",
 "demo.docs.agent": "小智·单证专员",
 "demo.docs.todayCount": "今日处理",
 "demo.docs.processing": "处理中",
 "demo.docs.ocrRecognizing": "OCR识别中",
 "demo.docs.fieldExtract": "字段提取",
 "demo.docs.formatCheck": "格式校验",
 "demo.docs.complete": "处理完成",
 "demo.docs.accuracy": "准确率",
 "demo.customs.agent": "小智·合规专员",
 "demo.customs.hsCode": "HS编码验证",
 "demo.customs.sanction": "制裁清单筛查",
 "demo.customs.origin": "原产地证明",
 "demo.customs.license": "许可证检查",
 "demo.customs.riskRate": "风险拦截率",
 "demo.finance.agent": "小智·结算专员",
 "demo.finance.reconciledAmount": "已对账金额",
 "demo.finance.task1": "核对运费账单...",
 "demo.finance.task2": "匹配杂费明细...",
 "demo.finance.task3": "标记差异项...",
 "demo.finance.task4": "生成对账报告...",
 "demo.finance.invoiceTrend": "对账趋势",
 "demo.finance.matchRate": "匹配率",
 "demo.finance.dsoOptimize": "DSO优化",
 "demo.finance.complete": "对账完成",
 "demo.finance.saved": "已发现差异并标记",
 "demo.risk.agent": "小智·风控专员",
 "demo.risk.handledAlerts": "已处理警报",
 "demo.risk.task1": "扫描订单异常...",
 "demo.risk.task2": "评估信用风险...",
 "demo.risk.task3": "检查合规状态...",
 "demo.risk.task4": "生成风险报告...",
 "demo.risk.alertTrend": "风险趋势",
 "demo.risk.blockRate": "拦截率",
 "demo.risk.riskScore": "风险评分",
 "demo.risk.complete": "风控检查完成",
 "demo.risk.result": "发现2项中风险，已自动处理",
 "demo.days": "天",
 "demo.responseSpeed": "响应速度",
 "demo.quoteTrend": "报价趋势",
 "demo.quoteAccuracy": "报价准确率",
 "demo.marginOptimize": "毛利优化",
 "demo.optimalPlanGenerated": "最优方案已生成",
 "demo.book.module1": "航线查询",
 "demo.book.module2": "舱位确认",
 "demo.book.module3": "订舱提交",
 "demo.book.stat1": "条可选航线",
 "demo.book.stat2": "平均响应",
 "demo.book.stat3": "成功率",
 "demo.book.todayBooking": "今日订舱",
 "demo.book.successRateLabel": "成功率",
 "demo.book.unit": "单",
 "demo.docs.progressLabel": "处理进度",
 "demo.docs.efficiency": "处理效率",
 "demo.docs.trendLabel": "7天趋势",
 "demo.docs.speed": "处理速度",
 "demo.docs.speedUnit": "秒/页",
 "demo.docs.accuracyLabel": "识别准确率",
 "demo.customs.complianceTrend": "合规趋势",
 "demo.customs.todayCheck": "今日检查",
 "demo.finance.arTrend": "AR趋势",
 "demo.finance.dsoReduction": "DSO降低率",
 "demo.finance.completed": "已完成",
 "demo.finance.waiting": "等待中",
 "demo.risk.monitoring": "实时风险监控中...",
 "demo.risk.alertsHandled": "已处理警报",
 "demo.risk.riskTrend": "风险趋势",
 "demo.risk.riskReduction": "风险降低",
 "demo.risk.levelLow": "低",
 "demo.risk.levelMedium": "中",
 "demo.risk.levelHigh": "高",
 "demo.status.working": "工作中",
 "demo.status.idle": "待命",
 "demo.status.complete": "已完成",
 // Worker Cards
 "workerCard.rate.name": "NovaRate",
 "workerCard.rate.role": "航价智算官",
 "workerCard.rate.ability": "自动优化报价毛利",
 "workerCard.rate.roi": "毛利 5-10%",
    "workerCard.quote.name": "NovaSales",
 "workerCard.quote.role": "多维报价师",
 "workerCard.quote.ability": "2分钟生成报价单",
 "workerCard.quote.roi": "速度 60倍",
 "workerCard.book.name": "NovaBook",
 "workerCard.book.role": "订舱调度官",
 "workerCard.book.ability": "自动向船司订舱",
 "workerCard.book.roi": "人效 300%",
 "workerCard.docs.name": "NovaDocs",
 "workerCard.docs.role": "单证工厂主管",
 "workerCard.docs.ability": "自动识别和审单",
 "workerCard.docs.roi": "错单率 0.1%",
 "workerCard.customs.name": "NovaCustoms",
 "workerCard.customs.role": "合规风控顾问",
 "workerCard.customs.ability": "自动检查合规",
 "workerCard.customs.roi": "合规风险 95%",
 "workerCard.finance.name": "NovaFinance",
 "workerCard.finance.role": "结算稽核官",
 "workerCard.finance.ability": "自动对账催款",
 "workerCard.finance.roi": "DSO 20%",
 "workerCard.risk.name": "NovaRisk",
 "workerCard.risk.role": "审计风控官",
 "workerCard.risk.ability": "全链路预警",
 "workerCard.risk.roi": "风险 95%",
 // Rate Worker
  "rateWorker.title": "NovaRate",
  "rateWorker.subtitle": "航价智算官",
 "rateWorker.desc": "智能运价管理专家，自动解析合约、聚合市场价格、制定报价策略并监控服务水平",
 "rateWorker.h1": "合约价解析与索引",
 "rateWorker.h2": "实时市场价聚合",
 "rateWorker.h3": "智能报价策略",
 "rateWorker.h4": "运价 SLA 监控与预警",
 "rateWorker.statValue": "99.5%",
 "rateWorker.statLabel": "运价 SLA 达成率",
 // Booking Worker
  "bookingWorker.title": "NovaBook",
  "bookingWorker.subtitle": "订舱调度官",
 "bookingWorker.desc": "智能订舱管理专家，直连船司航司、对接数字货代API、预测舱位容量并自动处理异常",
 "bookingWorker.h1": "船司/航司直连",
 "bookingWorker.h2": "NVOCC 与数字货代 API",
 "bookingWorker.h3": "容量预测",
 "bookingWorker.h4": "异常自动处理",
 "bookingWorker.statValue": "98.2%",
 "bookingWorker.statLabel": "订舱成功率",
 // Document Worker
  "documentWorker.title": "NovaDocs",
  "documentWorker.subtitle": "单证工厂主管",
 "documentWorker.desc": "智能单证处理专家，OCR与LLM结合智能识别、自动学习模板、检测异常并一键同步FMS系统",
 "documentWorker.h1": "OCR + LLM 智能识别",
 "documentWorker.h2": "模板自学习",
 "documentWorker.h3": "异常检测",
 "documentWorker.h4": "FMS 一键同步",
 "documentWorker.statValue": "99.8%",
 "documentWorker.statLabel": "单证准确率",
 // Customs Worker
  "customsWorker.title": "NovaCustoms",
  "customsWorker.subtitle": "合规风控顾问",
 "customsWorker.desc": "智能关务合规专家，AI推荐HS编码、实时筛查制裁清单、查询各关区法规知识图谱并自动化合规检查",
 "customsWorker.h1": "HS 编码 AI 建议",
 "customsWorker.h2": "制裁清单实时筛查",
 "customsWorker.h3": "各关区法规知识图谱",
 "customsWorker.h4": "自动化合规检查",
 "customsWorker.statValue": "100%",
 "customsWorker.statLabel": "合规通过率",
 // Sales Worker (NovaSales)
 "salesWorker.title": "NovaSales",
 "salesWorker.subtitle": "AI 报价专家",
 "salesWorker.desc": "NovaSales 是 CargoNova 的智能报价 AI Agent，自动比价并生成完整报价单，极速响应客户询盘，输出规范专业的正式对外报价方案",
 "salesWorker.h1": "AI 报价生成",
 "salesWorker.h2": "报价效率升级",
 "salesWorker.h3": "专业化报价方案",
 "salesWorker.h4": "合规校验通过",
 "salesWorker.statValue": "90%+",
 "salesWorker.statLabel": "报价效率提升",
 // Animation texts - Sales Worker
 "salesAnim.subtitle": "AI 一键生成正式报价单",
 "salesAnim.phase1": "AI 报价生成",
 "salesAnim.phase2": "报价效率升级",
 "salesAnim.phase3": "专业化报价方案",
 "salesAnim.needsInput": "客户需求录入",
 "salesAnim.tagBiz": "业务类型",
 "salesAnim.tagParams": "需求参数",
 "salesAnim.tagSLA": "时效要求",
 "salesAnim.tagStd": "服务标准",
 "salesAnim.quoteTitle": "报价单",
 "salesAnim.rowBase": "基础费用",
 "salesAnim.rowExtra": "附加项",
 "salesAnim.rowCycle": "服务周期",
 "salesAnim.rowTerms": "权责条款",
 "salesAnim.aiDone": "AI 生成完成",
 "salesAnim.manual": "传统人工报价",
 "salesAnim.ai": "NovaSales AI 报价",
 "salesAnim.hours": "平均数小时",
 "salesAnim.minutes": "仅需数分钟",
 "salesAnim.uplift": "效率提升 90%+",
 "salesAnim.checkPrice": "价格合规校验",
 "salesAnim.checkMarket": "市场行情匹配",
 "salesAnim.checkTerms": "服务条款规范",
 "salesAnim.checkBrand": "品牌样式统一",
 "salesAnim.checkRisk": "风险项提示",
 "salesAnim.formal": "正式对外报价单",
 "salesAnim.standby": "待命中",
 "salesAnim.running": "生成中",
 "salesAnim.complete": "已完成",
 // Animation texts - Booking Worker
 "bookingAnim.carrierConnected": "已直连 ",
 "bookingAnim.carriers": "+ 船司",
 "bookingAnim.responseSpeed": "响应速度：",
 "bookingAnim.predictionAccuracy": "预测准确率：",
 "bookingAnim.todayHandled": "今日处理：",
 "bookingAnim.times": " 次",
 "bookingAnim.exceptionResolved": "异常已解决",
 "bookingAnim.apiResponse": "接口响应速度：10ms/次",
 // Animation texts - Customs Worker
 "customsAnim.subtitle": "智能海关合规自动化流程",
 "customsAnim.processComplete": "流程完成",
 "customsAnim.analyzing": "AI 分析商品描述...",
 "customsAnim.product": "商品: 电子芯片模组",
 "customsAnim.match": "匹配",
 "customsAnim.processorController": "处理器及控制器",
 "customsAnim.todaySuggestions": "今日建议",
 "customsAnim.screeningEntities": "正在筛查实体名单...",
 "customsAnim.noSanctionRisk": "无制裁风险",
 "customsAnim.crossVerified": "已完成多数据库交叉验证",
 "customsAnim.todayPassed": "今日通过",
 "customsAnim.customsRegulations": "海关法规",
 "customsAnim.import": "进口",
 "customsAnim.export": "出口",
 "customsAnim.comprehensiveAnalysis": "综合合规分析",
 "customsAnim.hsVerify": "HS验证",
 "customsAnim.sanctionScreen": "制裁筛查",
 "customsAnim.regulationMatch": "法规匹配",
 "customsAnim.riskAssess": "风险评估",
 "customsAnim.reportGenerated": "合规报告已生成",
 "customsAnim.autoCheckComplete": "自动化检查完成",
 "customsAnim.riskLevel": "风险等级",
 "customsAnim.low": "低",
 "customsAnim.confidence": "置信度",
 "customsAnim.timeTaken": "耗时",
 "customsAnim.standby": "待机中",
 "customsAnim.completed": "已完成",
 "customsAnim.processing": "处理中",
 "customsAnim.step": "步骤",
 "customsAnim.monitoring": "实时监控中",
 "customsAnim.waitingProcess": "等待处理...",
 // Animation texts - Document Worker
 "docAnim.recognizing": "识别中...",
 "docAnim.newTemplates": "已自学习 2 种新单证格式",
 "docAnim.anomalyFixed": "已检测并修正 1 处异常",
 "docAnim.syncing": "同步中...",
 "docAnim.bl": "B/L",
 "docAnim.productName": "货物品名: 电子产品",
 "docAnim.hsCode": "HS编码: 8471.30",
 "docAnim.weight": "重量: 2,500 KG",
 "docAnim.pieces": "件数: 150 件",
 "docAnim.docCheck": "单证检验",
 "docAnim.packingQty": "装箱数量:",
 "docAnim.correct": "150 件 ✓",
 "docAnim.incorrect": "1500 件 ✗",
 "docAnim.fmsSystem": "FMS 系统",
 "docAnim.syncedToFms": "已同步至 FMS",
 "docAnim.templateBl": "提单",
 "docAnim.templateInvoice": "发票",
 "docAnim.templatePacking": "装箱单",
 "docAnim.templateCustoms": "报关单",
 "docAnim.templateOrigin": "原产地",
 "docAnim.accuracy": "识别准确率:",
 // Social Proof Section
 "socialProof.title": "客户实证",
 "socialProof.desc": "领先货代企业信赖 CargoNova",
 "socialProof.stat1": "货代企业信任",
 "socialProof.stat2": "快速上线",
 "socialProof.stat2Unit": "个月",
 "socialProof.stat3": "原生架构",
 "socialProof.stat4": "东南亚市场领先",
 "socialProof.certs": "安全认证",
 "socialProof.testimonial1.quote": "CargoNova 彻底改变了我们的运价管理。过去需要数小时的工作现在几秒钟就能完成，而且准确率更高。",
 "socialProof.testimonial1.avatar": "运",
 "socialProof.testimonial1.name": "运营总监",
 "socialProof.testimonial1.company": "环球物流集团",
 "socialProof.testimonial2.quote": "AI Agent 在夜间处理我们的单证。我们醒来看到的是已处理的货运，而不是堆积的文书工作。",
 "socialProof.testimonial2.avatar": "首",
 "socialProof.testimonial2.name": "首席执行官",
 "socialProof.testimonial2.company": "太平洋货运方案",
 // Shipping Operations Section
 "shipping.title": "我们提供的服务",
 "shipping.desc": "一站式海运/空运运营管理平台，智能化赋能物流全流程",
 "shipping.crm.header.customer": "客户",
 "shipping.crm.header.company": "公司",
 "shipping.crm.header.status": "状态",
 "shipping.crm.header.stage": "阶段",
 "shipping.crm.customer1": "李明辉",
 "shipping.crm.company1": "华为科技",
 "shipping.crm.status1": "VIP 客户",
 "shipping.crm.stage1": "运输中",
 "shipping.crm.customer2": "王晓峰",
 "shipping.crm.company2": "阿里巴巴",
 "shipping.crm.status2": "长期合作",
 "shipping.crm.stage2": "海运订舱中",
 "shipping.crm.customer3": "张伟",
 "shipping.crm.company3": "腾讯控股",
 "shipping.crm.status3": "新客户",
 "shipping.crm.stage3": "空运询价待回复",
 "shipping.crm.customer4": "陈思远",
 "shipping.crm.company4": "比亚迪",
 "shipping.crm.status4": "VIP 客户",
 "shipping.crm.stage4": "已签收",
 "shipping.crm.title": "运单客户 CRM",
 "shipping.crm.desc": "在集中化系统中管理海运/空运全流程的客户与订单线索，搭配智能跟进追踪，同步记录客户需求、运单进度与沟通记录。",
 "shipping.worker.sea": "海运 AI Agent",
 "shipping.worker.seaRole": "订舱专员",
 "shipping.worker.air": "空运 AI Agent",
 "shipping.worker.airRole": "单据审核员",
 "shipping.worker.doc": "单据处理 AI Agent",
 "shipping.worker.docRole": "客服助手",
 "shipping.worker.title": "AI Agent 管理",
 "shipping.worker.desc": "为不同运输场景分配 AI Agent 角色（海运订舱/空运对接/单据处理），支持实时协同与工作流调整。",
 "shipping.resource.20ft": "20尺集装箱",
 "shipping.resource.40ft": "40尺集装箱",
 "shipping.resource.title": "运输资源预约",
 "shipping.resource.desc": "跨航线/港口预订海运舱位、空运货舱、冷藏集装箱等运输资源，实时显示可用库存。",
 "shipping.scan.billTitle": "海运提单",
 "shipping.scan.origin": "发货港：上海",
 "shipping.scan.dest": "目的港：洛杉矶",
 "shipping.scan.title": "AI 单据扫描",
 "shipping.scan.desc": "通过手机端实时扫描海运提单、空运运单、装箱单等单据，自动识别关键信息并同步至系统。",
 "shipping.fee.title": "费用明细",
 "shipping.fee.verified": "已核算",
 "shipping.fee.port": "港口杂费",
 "shipping.fee.insurance": "保险费",
 "shipping.fee.transport": "运输费",
 "shipping.fee.total": "总计",
 "shipping.fee.linked": "自动关联订单",
 "shipping.fee.cardTitle": "AI 费用结算",
 "shipping.fee.cardDesc": "实时上传运输相关票据（港口杂费、保险费等），AI 自动识别费用项并归类，生成结算账单。",
 // AI Tech Section
 "ai.badge": "核心技术 · 60%+ 智能化能力",
 "ai.title1": "",
 "ai.title2": "AI智能化功能",
 "ai.subtitle": "CargoNova AI 货代系统的四大核心 AI 能力，构建下一代智能物流基础设施",
 "ai.native.title": "AI Native 架构",
 "ai.native.subtitle": "原生AI驱动",
 "ai.native.desc": "从底层架构到用户体验，全面AI原生设计。智能决策、预测分析、自适应学习，让系统越用越聪明",
 "ai.native.h1": "深度学习引擎",
 "ai.native.h2": "实时决策优化",
 "ai.native.h3": "自然语言交互",
 "ai.native.h4": "预测性分析",
 "ai.native.statValue": "99.2%",
 "ai.native.statLabel": "决策准确率",
 "ai.worker.title": "AI Agent",
 "ai.worker.subtitle": "AI Agents",
 "ai.worker.desc": "7x24小时不间断工作的智能 AI Agent，自动处理报关、订舱、跟踪等繁琐任务，释放人力专注高价值工作",
 "ai.worker.h1": "自动化报关",
 "ai.worker.h2": "智能订舱",
 "ai.worker.h3": "异常处理",
 "ai.worker.h4": "客户服务",
 "ai.worker.statValue": "85%",
 "ai.worker.statLabel": "人力节省",
 "ai.rpa.title": "RPA 自动化",
 "ai.rpa.subtitle": "流程自动化机器人",
 "ai.rpa.desc": "端到端业务流程自动化，从数据录入到报表生成，从系统对接到邮件处理，全链路无缝衔接",
 "ai.rpa.h1": "多系统集成",
 "ai.rpa.h2": "自动数据同步",
 "ai.rpa.h3": "智能工作流",
 "ai.rpa.h4": "异常告警",
 "ai.rpa.statValue": "10x",
 "ai.rpa.statLabel": "效率提升",
 "ai.ocr.title": "智能 OCR",
 "ai.ocr.subtitle": "文档智能识别",
 "ai.ocr.desc": "深度学习驱动的OCR技术，秒级识别提单、发票、装箱单等各类物流单证，准确率高达99%+",
 "ai.ocr.h1": "多语言识别",
 "ai.ocr.h2": "表格提取",
 "ai.ocr.h3": "手写体识别",
 "ai.ocr.h4": "智能分类",
 "ai.ocr.statValue": "99.5%",
 "ai.ocr.statLabel": "识别准确率",
 "ai.learnMore": "了解更多",
 "ai.cta": "准备好体验AI智能物流了吗？",
 "ai.ctaBtn": "申请演示",
 // AI Architecture Card
 "ai.arch.badge": "AI Native Architecture",
 "ai.arch.title": "智能决策引擎",
 "ai.arch.layer1": "业务应用层",
 "ai.arch.layer1Sub": "Business Application",
 "ai.arch.layer1.i1": "运价查询",
 "ai.arch.layer1.i2": "订舱管理",
 "ai.arch.layer1.i3": "轨迹追踪",
 "ai.arch.layer1.i4": "账单结算",
 "ai.arch.layer2": "AI Agent 执行层",
 "ai.arch.layer2Sub": "AI Agent",
 "ai.arch.layer2.i1": "任务编排",
 "ai.arch.layer2.i2": "流程自动化",
 "ai.arch.layer2.i3": "异常处理",
 "ai.arch.layer2.i4": "智能调度",
 "ai.arch.layer3": "AI 底座层",
 "ai.arch.layer3Sub": "AI Foundation",
 "ai.arch.layer3.i1": "大语言模型",
 "ai.arch.layer3.i2": "OCR识别",
 "ai.arch.layer3.i3": "机器学习",
 "ai.arch.layer3.i4": "知识图谱",
 "ai.arch.dataFlow": "数据实时流转中",
 // Digital Employee Card
 "ai.emp.title": "智能化员工",
 "ai.emp.status": "在线待命",
 "ai.emp.booking": "订舱处理",
 "ai.emp.bookingBubble": "自动匹配舱位资源",
 "ai.emp.bookingStats": "今日处理订舱：",
 "ai.emp.doc": "单据审核",
 "ai.emp.docBubble": "智能识别审核中...",
 "ai.emp.ocrRate": "OCR 识别准确率 99.2%",
 // RPA Card
 "ai.rpaCard.title": "流程自动化",
 "ai.rpaCard.pipeline": "RPA Pipeline",
 "ai.rpaCard.bill": "海运提单录入",
 "ai.rpaCard.billBubble": "OCR 识别完成",
 "ai.rpaCard.billDone": "票已录入",
 "ai.rpaCard.cabin": "船公司舱位同步",
 "ai.rpaCard.cabinBubble": "舱位锁定完成",
 "ai.rpaCard.cabinDone": "已锁定",
 "ai.rpaCard.fee": "港口费用核对",
 "ai.rpaCard.feeBubble": "已推送结算",
 "ai.rpaCard.feeDone": "已推送结算",
 "ai.rpaCard.complete": "RPA 流程执行完成",
 "ai.rpaCard.running": "自动化流程运行中...",
 "ai.rpaCard.order": "订单",
 "ai.rpaCard.misc": "杂费",
 "ai.rpaCard.diff": "差额：0",
 "ai.rpaCard.locked": "舱位锁定",
 "ai.rpaCard.entered": "已录入：",
 "ai.rpaCard.tickets": "票",
 // OCR Card
 "ai.ocrCard.title": "文档识别",
 "ai.ocrCard.system": "海运订舱系统",
 "ai.ocrCard.upload": "拖拽 / 点击上传海运单据",
 "ai.ocrCard.uploadSub": "（提单 / 装箱单）",
 "ai.ocrCard.file": "海运提单.pdf",
 "ai.ocrCard.structure": "结构化信息",
 "ai.ocrCard.synced": "信息已同步至订舱模块",
 "ai.ocrCard.extracted": "已提取",
 "ai.ocrCard.archived": "已识别归档",
 "ai.ocrCard.accuracy": "识别准确率：",
 "ai.ocrCard.field1": "货物品名",
 "ai.ocrCard.field1Val": "电子元器件",
 "ai.ocrCard.field2": "HS 编码",
 "ai.ocrCard.field2Val": "8542.31.00",
 "ai.ocrCard.field3": "毛重",
 "ai.ocrCard.field3Val": "2,450 KG",
 "ai.ocrCard.field4": "目的港",
 "ai.ocrCard.field4Val": "Rotterdam",
 "ai.ocrCard.wait": "等待上传文档...",
 "ai.ocrCard.loading": "正在加载文档...",
 "ai.ocrCard.recognizing": "OCR 识别中...",
 "ai.ocrCard.extracting": "信息提取中...",
 "ai.ocrCard.syncing": "数据同步中...",
 "ai.ocrCard.complete": "识别完成",
 // Partners Section
 "partners.badge": "合作伙伴",
 "partners.title": "合作伙伴",
 "partners.desc": "与全球顶级航运公司、航空公司及技术公司深度合作，为您提供最优质的物流服务",
 "partners.shipping": "航运合作伙伴",
 "partners.air": "航空合作伙伴",
 "partners.ports": "港口覆盖",
 "partners.countries": "国家/地区",
 // About Section
 "about.badge": "关于我们",
 "about.title1": "开创",
 "about.title2": "智能物流",
 "about.title3": "新纪元",
 "about.imgAlt": "CargoNova专业团队协作办公场景",
 "about.p1": "洞隐科技——CargoNova是洞隐科技旗下专注于国际货代行业的智能化产品，融合大语言模型(LLM)、RPA自动化、智能OCR等前沿技术，创新性地推出涵盖运价管理、智能报价、订舱管理、单证处理、关务合规、结算稽核、风险管控七大核心模块的 AI Agent 矩阵。CargoNova秉承「让每一票货都智能运营」的使命，通过云原生架构支持多语言、多币种、多法规的全球化部署，助力货代企业实现运价SLA达成率99.5%、订舱成功率98.2%、单证准确率99.8%的卓越运营表现。",
 "about.p1Link": "https://en.deepinsights.com.cn/",
 "about.p2": "",
 "about.learnMoreDongyin": "了解更多 Deep Insights →",
 "about.stat1": "成立年份",
 "about.stat2": "专业团队",
 "about.stat3": "融资完成",
 "about.newStat1": "供应链数字化经验",
 "about.newStat2": "行业头部客户",
 "about.newStat3": "入选Gartner魔力象限",
 "about.newStat4": "知识产权",
 "about.newStat5": "国内500强客户",
 "about.newStat6": "物流服务商",
 "about.mission": "使命",
 "about.missionDesc": "以AI驱动供应链数智化转型，为制造、零售、物流企业提供端到端的智能解决方案",
 "about.vision": "愿景",
 "about.visionDesc": "成为全球领先的供应链数智化平台，助力企业实现高效、透明、可持续的供应链运营",
 "about.values": "价值观",
 "about.valuesDesc": "技术创新、客户成功、开放协作、持续进化",
 "about.team": "团队",
 "about.teamDesc": "西安与厦门双研发中心，汇聚供应链与AI领域20余年经验的专业团队",
 "about.companyIntro": "公司简介",
 "about.coreValues": "企业理念",
 "about.highlight1Title": "一体化云平台",
 "about.highlight1Desc": "OMS、TMS、WMS、YMS、GTM五大云产品一体化",
 "about.highlight2Title": "行业数字化",
 "about.highlight2Desc": "航运、货代、综合物流三大数字化产品线",
 "about.highlight3Title": "AI智能产品",
 "about.highlight3Desc": "DI.AI供应链智能产品，CargoNova产品提供AI Native、AI Agents，融合运筹算法与大模型",
 "about.highlight4Title": "头部客户认可",
 "about.highlight4Desc": "DHL、中国外运、香港鸿安、KORMAN INTERNATIONAL（新加坡、香港、印尼）",
 "about.companyData.title": "公司数据",
 "about.companyData.parentLabel": "母公司",
 "about.companyData.parentValue": "Deep Insights（洞隐科技）",
 "about.companyData.hqLabel": "总部",
 "about.companyData.hqValue": "Singapore (Marina Bay Financial Centre)",
 "about.companyData.productLabel": "核心产品线",
 "about.companyData.productValue": "WMS Cloud, TMS Cloud, CargoNova",
 "about.ourNumbers.title": "Our Numbers",
 "about.ourNumbers.stat1Label": "服务货运代理公司",
 "about.ourNumbers.stat1Value": "600+",
 "about.ourNumbers.stat2Label": "国家/地区覆盖",
 "about.ourNumbers.stat2Value": "30+",
 "about.ourNumbers.stat3Label": "准时交付率",
 "about.ourNumbers.stat3Value": "99.5%",
 "about.parentCompanyText": "CargoNova is part of the Deep Insights product suite, alongside WMS Cloud and TMS Cloud.",
 "about.lastUpdated": "Last Updated: June 2026",
 "about.timeline": "发展历程",
 "about.milestone2003_1": "Quantum Asia、Gillion成立",
 "about.milestone2003_2": "ERP软件实施",
 "about.milestone2003_3": "为大型物流企业开发供应链管理软件",
 "about.milestone2008_1": "聚焦供应链执行软件",
 "about.milestone2008_2": "入选上海市高新技术企业名单",
 "about.milestone2008_3": "获上海市重点软件企业",
 "about.milestone2014_1": "获国家高新区百新企业",
 "about.milestone2014_2": "基于云架构和微服务重构SCM产品",
 "about.milestone2016_1": "子公司Gillion Software完成张江汉世纪融资",
 "about.milestone2016_2": "拓峰收购张江汉世纪股份",
 "about.milestone2016_3": "子公司Quantum Asia获得用友战略投资",
 "about.milestone2019_1": "与华中科技大学合作，基于数据及AI技术，落地供应链优化产品",
 "about.milestone2019_2": "入选Gartner TMS、WMS报告",
 "about.milestone2019_3": "完善服务中台的应用",
 "about.milestone2022_1": "洞隐科技成立，完成隐山资本A轮融资",
 // Contact Section
 "contact.badge": "联系我们",
 "contact.title": "准备好转型您的货运业务了吗？",
 "contact.desc": "加入已部署 AI Agent 矩阵的领先货代企业",
 "contact.help": "需要帮助？",
 "contact.helpDesc": "我们的AI客服和专业团队24/7在线，随时为您解答",
 "contact.chat": "在线咨询",
 "contact.phone": "电话",
 "contact.email": "邮箱",
 "contact.address": "地址",
 "contact.addressVal": "上海市浦东新区陆家嘴金融中心",
 "contact.hours": "工作时间",
 "contact.hoursVal": "周一至周五 9:00-18:00",
 "contact.formTitle": "发送消息",
 "contact.name": "姓名",
 "contact.namePh": "您的姓名",
 "contact.company": "公司",
 "contact.companyPh": "公司名称",
 "contact.emailPh": "your@email.com",
 "contact.phonePh": "联系电话",
 "contact.message": "留言内容",
 "contact.messagePh": "请描述您的需求...",
 "contact.send": "发送消息",
 // CTA
 "cta.demo": "预约演示",
 "cta.download": "下载资料",
 // Solutions Page
 "solutions.title": "解决方案",
 "solutions.subtitle": "为不同类型货代企业量身定制的货代系统与货代平台方案",
 "solutions.painPointsTitle": "痛点",
 "solutions.painPointsSubtitle": "常见业务挑战",
 "solutions.solutionsTitle": "CargoNova 如何解决",
 "solutions.solutionsSubtitle": "CargoNova 智能方案",
 "solutions.solutionsBadge": "智能解决",
 "solutions.improvementsTitle": "预期改善",
 "solutions.whySuitable": "为什么特别适合您",
 "solutions.ctaDiagnosis": "申请免费诊断",
 "solutions.tab1.label": "为东南亚本地货代",
 "solutions.tab1.hero": "您是东南亚的货代企业，想在数字化竞争中领先？",
 "solutions.tab1.heroSub": "CargoNova 是为您设计的 ERP 平台",
 "solutions.tab1.pain1": "系统太复杂，员工培训成本高",
 "solutions.tab1.pain2": "竞争对手在数字化，我被 Excel 拖累",
 "solutions.tab1.pain3": "东南亚合规法规复杂，容易出错",
 "solutions.tab1.sol1": "界面完全本地化，操作像微信一样简单",
 "solutions.tab1.sol2": "内置东南亚 e-Customs，合规自动搞定",
 "solutions.tab1.sol3": "7 位 AI Agent 自动报价、订舱、对账",
 "solutions.tab1.imp1": "操作人效",
 "solutions.tab1.imp2": "系统上线",
 "solutions.tab1.imp3": "员工流失率",
 "solutions.tab1.impVal1": "↑ 300%",
 "solutions.tab1.impVal2": "3 天",
 "solutions.tab1.impVal3": "↓ 50%",
 "solutions.tab1.why": "我们是为东南亚本地企业设计的，完全理解您的痛点和工作方式",
 "solutions.tab2.label": "为中国出海企业",
 "solutions.tab2.hero": "全球出海，分公司数据混乱？",
 "solutions.tab2.heroSub": "CargoNova 是您的全球一体化管理平台",
 "solutions.tab2.pain1": "总部看不清海外分公司的运营情况",
 "solutions.tab2.pain2": "各分公司数据永远对不上",
 "solutions.tab2.pain3": "汇报流程复杂，决策缓慢",
 "solutions.tab2.sol1": "总部实时看所有分公司数据",
 "solutions.tab2.sol2": "一套系统，多国使用，界面自动切换",
 "solutions.tab2.sol3": "既给一线灵活性，又给总部控制权",
 "solutions.tab2.imp1": "业务增长",
 "solutions.tab2.imp2": "人力成本增加",
 "solutions.tab2.imp3": "对账周期",
 "solutions.tab2.impVal1": "2-3 倍",
 "solutions.tab2.impVal2": "< 20%",
 "solutions.tab2.impVal3": "↓ 85%",
 "solutions.tab2.why": "我们的 7 位 AI Agent 能帮您统一管理全球分公司，消除数据孤岛",
 "solutions.tab3.label": "为全球型货代",
 "solutions.tab3.hero": "业务快速增长，成本压力山大？",
 "solutions.tab3.heroSub": "CargoNova 让您用少一半的人干三倍的活",
 "solutions.tab3.pain1": "业务翻倍，必须招人翻倍，利润被吃掉",
 "solutions.tab3.pain2": "系统瓶颈和人力成本同时压力山大",
 "solutions.tab3.pain3": "需要又快又稳的数字化解决方案",
 "solutions.tab3.sol1": "让您用 60 人的团队干 150 人的活",
 "solutions.tab3.sol2": "直接改善利润率（工资成本从 40% → 15%）",
 "solutions.tab3.sol3": "快速部署（3 个月），立刻见效",
 "solutions.tab3.imp1": "人效",
 "solutions.tab3.imp2": "利润率",
 "solutions.tab3.imp3": "上线时间",
 "solutions.tab3.impVal1": "↑ 250%",
 "solutions.tab3.impVal2": "↑ 13%",
 "solutions.tab3.impVal3": "3 个月",
 "solutions.tab3.why": "我们的快速部署能力刚好解决您「既要快速增长又要控制成本」的矛盾",
 // Customers Page
 "customers.pageTitle": "客户成功案例",
    "customers.pageSubtitle": "看看货代企业如何用 CargoNova 转型升级",
    "customers.caseStudiesHeading": "客户成功案例",
 "customers.metricsTitle": "客户成功数据",
 "customers.metric1": "信任企业",
 "customers.metric2": "个月快速上线",
 "customers.metric3": "效率提升",
 "customers.metric4": "持续运营",
 "customers.challengeLabel": "挑战",
 "customers.solutionLabel": "解决方案",
 "customers.resultsLabel": "成果",
 "customers.testimonialsTitle": "客户心声",
 "customers.ctaTitle": "准备好书写您的成功故事了吗？",
 "customers.ctaSubtitle": "加入已部署 AI Agent 矩阵的领先货代企业",
 "customers.case1.type": "东南亚本地货代",
 "customers.case1.company": "东南亚领先货代公司",
 "customers.case1.challenge": "系统太复杂培训成本高，竞争对手都在数字化而自己还在用 Excel",
 "customers.case1.solution": "部署7位 AI Agent，多语言界面，内置东南亚 e-Customs 合规",
 "customers.case1.result1": "操作人效",
 "customers.case1.result2": "天系统上线",
 "customers.case1.result3": "员工流失率",
 "customers.case1.quote": "CargoNova 一夜之间改变了我们的运营。本地化界面让员工轻松上手。",
 "customers.case2.type": "中国出海企业",
 "customers.case2.company": "环球贸易方案",
 "customers.case2.challenge": "总部看不清海外分公司运营情况，各分公司数据永远对不上",
 "customers.case2.solution": "全球一体化管理平台，总部实时查看所有分公司数据",
 "customers.case2.result1": "业务增长",
 "customers.case2.result2": "人力成本增加",
 "customers.case2.result3": "对账周期",
 "customers.case2.quote": "终于可以实时看到所有分公司数据了。决策变得即时高效。",
 "customers.case3.type": "全球型货代",
 "customers.case3.company": "全球货运伙伴",
 "customers.case3.challenge": "业务快速增长但成本压力巨大，业务翻倍就必须招人翻倍",
 "customers.case3.solution": "AI Agent 让同样的团队产出提升3倍，直接改善利润率",
 "customers.case3.result1": "人效",
 "customers.case3.result2": "利润率",
 "customers.case3.result3": "个月上线",
 "customers.case3.quote": "利润率从12%提升到28%。投资回报立竿见影。",
 "customers.testimonial1.quote": "CargoNova 彻底改变了我们的运价管理。过去需要数小时的工作现在几秒钟就能完成，而且准确率更高。",
 "customers.testimonial1.author": "运营总监",
 "customers.testimonial1.company": "环球物流集团",
 "customers.testimonial2.quote": "AI Agent 在夜间处理我们的单证。我们醒来看到的是已处理的货运，而不是堆积的文书工作。",
 "customers.testimonial2.author": "首席执行官",
 "customers.testimonial2.company": "太平洋货运方案",
 // Footer
 "footer.slogan": "AI Native 智能物流平台，用技术连接全球，让物流更智能",
 "footer.services": "服务",
 "footer.services.1": "海运服务",
 "footer.services.2": "空运服务",
 "footer.services.3": "智能运价",
 "footer.services.4": "智能结算",
 "footer.tech": "技术",
 "footer.tech.1": "AI Native",
 "footer.tech.2": "AI Agent",
 "footer.tech.3": "RPA自动化",
 "footer.tech.4": "智能OCR",
 "footer.company": "公司",
 "footer.company.1": "关于我们",
 "footer.company.2": "合作伙伴",
 "footer.company.3": "新闻动态",
 "footer.company.4": "加入我们",
 "footer.support": "支持",
 "footer.support.1": "帮助中心",
 "footer.support.2": "API文档",
 "footer.support.3": "联系我们",
 "footer.support.4": "隐私政策",
 "footer.deepInsightsTagline": "Powered by 洞隐科技（Deep Insights）",
 "footer.copyright": "© 2025-2026 Deep Insights., 保留所有权利.",
 "footer.terms": "服务条款",
 "footer.privacy": "隐私政策",
 "footer.cookies": "Cookie设置",
 },
 en: {
 // Navbar
    "nav.home": "Home",
    "nav.solutions": "Solutions",
    "nav.digitalWorkers": "AI Agents",
    "nav.cases": "Case Studies",
    "nav.about": "About Us",
    "nav.faq": "FAQ",
    "nav.consult": "Contact Us",
    "nav.faq.whatIs": "What is CargoNova",
    "nav.faq.compare": "CargoNova vs CargoWise",
    "nav.faq.aiAgents": "AI Agents",
    "nav.faq.pricing": "Pricing",
    "nav.faq.implementation": "Implementation",
    "nav.brand": "Smart",
    "nav.brandHighlight": "Logistics",
 // Hero
 "hero.badge": "End-to-End AI-Native Powered",
 "hero.title1": "AI Native + AI Agents, ",
 "hero.title2": "Redefining Freight Forwarding Efficiency",
 "hero.title3": "",
 "hero.desc": "CargoNova AI — AI-native freight forwarding software by Deep Insights, redefining end-to-end international logistics",
 "hero.cta1": "Get Started",
 "hero.cta2": "Watch Demo",
 "hero.stat1Value": "99.5%",
 "hero.stat1Label": "Rate SLA",
 "hero.stat2Value": "98.2%",
 "hero.stat2Label": "Booking Success Rate",
 "hero.stat3Value": "99.8%",
 "hero.stat3Label": "Document Accuracy",
 // Services Section
 "services.badge": "Why CargoNova",
 "services.title": "Why Choose CargoNova",
 "services.desc": "Built for the Future of International Freight Forwarding",
 "services.shipping.title": "AI Native + Cloud Native DNA",
 "services.shipping.desc": "AI-first design from the ground up, not retrofitted. True cloud-native architecture ensures infinite scaling and zero maintenance.",
 "services.shipping.f1": "AI-First Design",
 "services.shipping.f2": "Infinite Scaling",
 "services.shipping.f3": "Zero Maintenance",
 "services.air.title": "AI Agent Matrix",
 "services.air.desc": "Multiple specialized AI agents collaborate seamlessly, handling rates, booking, documentation, and customs across your entire operations.",
 "services.air.f1": "Rate Queries",
 "services.air.f2": "Booking & Docs",
 "services.air.f3": "Customs Processing",
 "services.pricing.title": "Global Ready",
 "services.pricing.desc": "Built-in multi-language, multi-currency, multi-regulation support. Deploy globally with local compliance from day one.",
 "services.pricing.f1": "Multi-language",
 "services.pricing.f2": "Multi-currency",
 "services.pricing.f3": "Multi-regulation",
 "services.settlement.title": "Seamless Integration",
 "services.settlement.desc": "See-Calculate-Write closed-loop automation. Connect to any legacy system without APIs. Digital workers bridge old and new systems seamlessly.",
 "services.settlement.f1": "Closed-loop Automation",
 "services.settlement.f2": "No API Required",
    "services.settlement.f3": "Legacy Integration",
    "services.learnMore": "Explore Solutions",
    "services.compareLink": "CargoNova vs CargoWise",
    // AI Agent Showcase
 "digitalWorker.badge": "AI Agents",
 "digitalWorker.title": "Your Exclusive AI Agent Team",
 "digitalWorker.desc": "Boss, you didn't just buy a system—you hired 7 top-tier employees",
 // Module Showcase - NovaQuote
 "module.quote.title": "NovaSales",
 "module.quote.subtitle": "Multi-Quote Expert",
 "module.quote.f1": "2-Min Quote",
 "module.quote.f2": "Multi-Compare",
 "module.quote.f3": "Smart Recommend",
 "module.quote.d1": "Auto-parse customer inquiries",
 "module.quote.d2": "Multi-carrier price comparison",
 "module.quote.d3": "Smart margin optimization",
 "module.quote.d4": "One-click quote generation",
 // Module Showcase - NovaRate
 "module.rate.title": "NovaRate",
 "module.rate.subtitle": "Rate Optimizer",
 "module.rate.f1": "Contract Parse",
 "module.rate.f2": "Price Index",
 "module.rate.f3": "SLA Monitor",
 "module.rate.d1": "Auto contract rate parsing",
 "module.rate.d2": "Real-time market aggregation",
 "module.rate.d3": "Smart quoting strategy",
 "module.rate.d4": "Rate SLA alerts",
 // Module Showcase - NovaBook
 "module.book.title": "NovaBook",
 "module.book.subtitle": "Booking Coordinator",
 "module.book.f1": "Carrier Direct",
 "module.book.f2": "Capacity Predict",
 "module.book.f3": "Exception Handle",
 "module.book.d1": "Carrier API direct connection",
 "module.book.d2": "Digital forwarder integration",
 "module.book.d3": "Smart capacity prediction",
 "module.book.d4": "Auto exception handling",
 // Module Showcase - NovaDocs
 "module.docs.title": "NovaDocs",
 "module.docs.subtitle": "Document Supervisor",
 "module.docs.f1": "OCR Recognition",
 "module.docs.f2": "Template Learning",
 "module.docs.f3": "FMS Sync",
 "module.docs.d1": "OCR+LLM smart recognition",
 "module.docs.d2": "Template self-learning",
 "module.docs.d3": "Auto anomaly detection",
 "module.docs.d4": "One-click FMS sync",
 // Module Showcase - NovaCustoms
 "module.customs.title": "NovaCustoms",
 "module.customs.subtitle": "Compliance Advisor",
 "module.customs.f1": "HS Code",
 "module.customs.f2": "Sanction Screen",
 "module.customs.f3": "Regulation Graph",
 "module.customs.d1": "AI HS code suggestions",
 "module.customs.d2": "Real-time sanctions screening",
 "module.customs.d3": "Customs regulations knowledge graph",
 "module.customs.d4": "Automated compliance check",
 // Module Showcase - NovaFinance
 "module.finance.title": "NovaFinance",
 "module.finance.subtitle": "Settlement Auditor",
 "module.finance.f1": "Auto Reconcile",
 "module.finance.f2": "Smart Collection",
 "module.finance.f3": "DSO Optimize",
 "module.finance.d1": "Auto invoice reconciliation",
 "module.finance.d2": "Smart variance flagging",
 "module.finance.d3": "Automated collection workflow",
 "module.finance.d4": "DSO cycle optimization",
 // Module Showcase - NovaRisk
 "module.risk.title": "NovaRisk",
 "module.risk.subtitle": "Risk Controller",
 "module.risk.f1": "Full Chain Monitor",
 "module.risk.f2": "Risk Alert",
 "module.risk.f3": "Smart Scoring",
 "module.risk.d1": "End-to-end business monitoring",
 "module.risk.d2": "Real-time risk alerts",
 "module.risk.d3": "Smart risk scoring",
 "module.risk.d4": "Compliance audit reports",
 // Module Demo Animations
 "demo.quote.agent": "Nova · Rate Expert",
 "demo.quote.request": "Shanghai to LA ocean freight quote",
 "demo.quote.task1": "Fetching latest rates...",
 "demo.quote.task2": "Calculating surcharges...",
 "demo.quote.task3": "Analyzing preferences...",
 "demo.quote.task4": "Generating quote...",
 "demo.quote.savedTime": "Time Saved",
 "demo.quote.priceTrend": "Price Trend",
 "demo.quote.accuracy": "Accuracy",
 "demo.quote.complete": "Analysis Complete",
 "demo.quote.recommend": "Recommend",
 "demo.rate.agent": "Nova · Rate Analyst",
 "demo.rate.request": "Query SHA → LAX best rate plan",
 "demo.rate.task1": "Collecting multi-platform rates...",
 "demo.rate.task2": "Analyzing price trends...",
 "demo.rate.task3": "Evaluating capacity & transit...",
 "demo.rate.task4": "Generating optimal plan...",
 "demo.rate.savedTime": "Time Saved",
 "demo.rate.priceTrend": "Rate Trend",
 "demo.rate.accuracy": "Quote Accuracy",
 "demo.rate.margin": "Margin Optimize",
 "demo.rate.complete": "Optimal plan generated",
 "demo.rate.result": "Sailing",
 "demo.book.agent": "Nova · Booking Expert",
 "demo.book.request": "Need booking: SHA → LAX, 2x40GP",
 "demo.book.reply1": "Found 3 spaces, recommend MSC sailing 5/20",
 "demo.book.confirm": "Confirm MSC",
 "demo.book.reply2": "Booked! Space ID: MSC2024520A",
 "demo.book.successRate": "Booking Success Rate",
 "demo.docs.agent": "Nova · Document Expert",
 "demo.docs.todayCount": "Today Processed",
 "demo.docs.processing": "Processing",
 "demo.docs.ocrRecognizing": "OCR Recognizing",
 "demo.docs.fieldExtract": "Field Extraction",
 "demo.docs.formatCheck": "Format Check",
 "demo.docs.complete": "Process Complete",
 "demo.docs.accuracy": "Accuracy",
 "demo.customs.agent": "Nova · Compliance Expert",
 "demo.customs.hsCode": "HS Code Verification",
 "demo.customs.sanction": "Sanctions Screening",
 "demo.customs.origin": "Origin Certificate",
 "demo.customs.license": "License Check",
 "demo.customs.riskRate": "Risk Block Rate",
 "demo.finance.agent": "Nova · Settlement Expert",
 "demo.finance.reconciledAmount": "Reconciled Amount",
 "demo.finance.task1": "Checking freight invoices...",
 "demo.finance.task2": "Matching fee details...",
 "demo.finance.task3": "Flagging variances...",
 "demo.finance.task4": "Generating reconciliation report...",
 "demo.finance.invoiceTrend": "Reconcile Trend",
 "demo.finance.matchRate": "Match Rate",
 "demo.finance.dsoOptimize": "DSO Optimize",
 "demo.finance.complete": "Reconciliation Complete",
 "demo.finance.saved": "Variances found and flagged",
 "demo.risk.agent": "Nova · Risk Expert",
 "demo.risk.handledAlerts": "Alerts Handled",
 "demo.risk.task1": "Scanning order anomalies...",
 "demo.risk.task2": "Evaluating credit risk...",
 "demo.risk.task3": "Checking compliance status...",
 "demo.risk.task4": "Generating risk report...",
 "demo.risk.alertTrend": "Risk Trend",
 "demo.risk.blockRate": "Block Rate",
 "demo.risk.riskScore": "Risk Score",
 "demo.risk.complete": "Risk check complete",
 "demo.risk.result": "Found 2 medium risks, auto-handled",
 "demo.days": "days",
 "demo.responseSpeed": "Response Speed",
 "demo.quoteTrend": "Quote Trend",
 "demo.quoteAccuracy": "Quote Accuracy",
 "demo.marginOptimize": "Margin Optimize",
 "demo.optimalPlanGenerated": "Optimal plan generated",
 "demo.book.module1": "Route Query",
 "demo.book.module2": "Space Confirm",
 "demo.book.module3": "Booking Submit",
 "demo.book.stat1": "routes available",
 "demo.book.stat2": "avg response",
 "demo.book.stat3": "success rate",
 "demo.book.todayBooking": "Today's Booking",
 "demo.book.successRateLabel": "Success Rate",
 "demo.book.unit": "orders",
 "demo.docs.progressLabel": "Progress",
 "demo.docs.efficiency": "Efficiency",
 "demo.docs.trendLabel": "7-day trend",
 "demo.docs.speed": "Speed",
 "demo.docs.speedUnit": "s/page",
 "demo.docs.accuracyLabel": "Recognition Accuracy",
 "demo.customs.complianceTrend": "Compliance Trend",
 "demo.customs.todayCheck": "Today's Checks",
 "demo.finance.arTrend": "AR Trend",
 "demo.finance.dsoReduction": "DSO Reduction",
 "demo.finance.completed": "Done",
 "demo.finance.waiting": "Pending",
 "demo.risk.monitoring": "Real-time risk monitoring...",
 "demo.risk.alertsHandled": "Alerts Handled",
 "demo.risk.riskTrend": "Risk Trend",
 "demo.risk.riskReduction": "Risk Reduction",
 "demo.risk.levelLow": "Low",
 "demo.risk.levelMedium": "Med",
 "demo.risk.levelHigh": "High",
 "demo.status.working": "Working",
 "demo.status.idle": "Standby",
 "demo.status.complete": "Complete",
 // Worker Cards
 "workerCard.rate.name": "NovaRate",
 "workerCard.rate.role": "Rate Optimizer",
 "workerCard.rate.ability": "Auto-optimize quote margins",
 "workerCard.rate.roi": "Margin 5-10%",
 "workerCard.quote.name": "NovaSales",
 "workerCard.quote.role": "Multi-Quote Expert",
 "workerCard.quote.ability": "Generate quotes in 2 min",
 "workerCard.quote.roi": "Speed 60x",
 "workerCard.book.name": "NovaBook",
 "workerCard.book.role": "Booking Coordinator",
 "workerCard.book.ability": "Auto-book with carriers",
 "workerCard.book.roi": "Efficiency 300%",
 "workerCard.docs.name": "NovaDocs",
 "workerCard.docs.role": "Document Supervisor",
 "workerCard.docs.ability": "Auto-recognize & review",
 "workerCard.docs.roi": "Error rate 0.1%",
 "workerCard.customs.name": "NovaCustoms",
 "workerCard.customs.role": "Compliance Advisor",
 "workerCard.customs.ability": "Auto-check compliance",
 "workerCard.customs.roi": "Compliance risk 95%",
 "workerCard.finance.name": "NovaFinance",
 "workerCard.finance.role": "Settlement Auditor",
 "workerCard.finance.ability": "Auto-reconcile & collect",
 "workerCard.finance.roi": "DSO 20%",
 "workerCard.risk.name": "NovaRisk",
 "workerCard.risk.role": "Risk Controller",
 "workerCard.risk.ability": "End-to-end alerts",
 "workerCard.risk.roi": "Risk 95%",
 // Rate Worker
  "rateWorker.title": "NovaRate",
  "rateWorker.subtitle": "Rate Optimizer",
 "rateWorker.desc": "Intelligent rate management expert, auto-parsing contracts, aggregating market prices, crafting quote strategies and monitoring SLA",
 "rateWorker.h1": "Contract Rate Parsing & Indexing",
 "rateWorker.h2": "Real-time Market Rate Aggregation",
 "rateWorker.h3": "Smart Quoting Strategy",
 "rateWorker.h4": "Rate SLA Monitoring & Alerts",
 "rateWorker.statValue": "99.5%",
 "rateWorker.statLabel": "Rate SLA Achievement",
 // Booking Worker
  "bookingWorker.title": "NovaBook",
  "bookingWorker.subtitle": "Booking Coordinator",
 "bookingWorker.desc": "Intelligent booking expert, connecting carriers directly, integrating freight forwarder APIs, predicting capacity and auto-handling exceptions",
 "bookingWorker.h1": "Carrier Direct Connection",
 "bookingWorker.h2": "NVOCC & Digital Forwarder API",
 "bookingWorker.h3": "Capacity Prediction",
 "bookingWorker.h4": "Auto Exception Handling",
 "bookingWorker.statValue": "98.2%",
 "bookingWorker.statLabel": "Booking Success Rate",
 // Document Worker
  "documentWorker.title": "NovaDocs",
  "documentWorker.subtitle": "Document Supervisor",
 "documentWorker.desc": "Intelligent document expert, combining OCR with LLM for smart recognition, auto-learning templates, detecting anomalies and one-click FMS sync",
 "documentWorker.h1": "OCR + LLM Recognition",
 "documentWorker.h2": "Template Self-Learning",
 "documentWorker.h3": "Anomaly Detection",
 "documentWorker.h4": "FMS One-Click Sync",
 "documentWorker.statValue": "99.8%",
 "documentWorker.statLabel": "Document Accuracy",
 // Customs Worker
  "customsWorker.title": "NovaCustoms",
  "customsWorker.subtitle": "Compliance Advisor",
 "customsWorker.desc": "Intelligent customs compliance expert, AI-powered HS code suggestions, real-time sanctions screening, customs regulations knowledge graph and automated compliance checks",
 "customsWorker.h1": "HS Code AI Suggestions",
 "customsWorker.h2": "Sanctions List Screening",
 "customsWorker.h3": "Customs Regulations Graph",
 "customsWorker.h4": "Automated Compliance Check",
 "customsWorker.statValue": "100%",
 "customsWorker.statLabel": "Compliance Rate",
 // Sales Worker (NovaSales)
 "salesWorker.title": "NovaSales",
 "salesWorker.subtitle": "AI Quotation Expert",
 "salesWorker.desc": "NovaSales is CargoNova's AI freight quotation agent: it compares live rates, auto-generates complete quotes in seconds, and outputs standardized professional formal quotations",
 "salesWorker.h1": "AI Quote Generation",
 "salesWorker.h2": "Efficiency Upgrade",
 "salesWorker.h3": "Professional Quotation",
 "salesWorker.h4": "Compliance Verified",
 "salesWorker.statValue": "90%+",
 "salesWorker.statLabel": "Efficiency Gain",
 // Animation texts - Sales Worker
 "salesAnim.subtitle": "AI-generated formal quotations in one click",
 "salesAnim.phase1": "AI Quote Generation",
 "salesAnim.phase2": "Efficiency Upgrade",
 "salesAnim.phase3": "Professional Quotation",
 "salesAnim.needsInput": "Client Needs Input",
 "salesAnim.tagBiz": "Business Type",
 "salesAnim.tagParams": "Requirements",
 "salesAnim.tagSLA": "SLA",
 "salesAnim.tagStd": "Service Standard",
 "salesAnim.quoteTitle": "Quotation",
 "salesAnim.rowBase": "Base Fee",
 "salesAnim.rowExtra": "Surcharges",
 "salesAnim.rowCycle": "Service Cycle",
 "salesAnim.rowTerms": "Terms",
 "salesAnim.aiDone": "AI Generated",
 "salesAnim.manual": "Manual Quoting",
 "salesAnim.ai": "NovaSales AI",
 "salesAnim.hours": "Avg. hours",
 "salesAnim.minutes": "Just minutes",
 "salesAnim.uplift": "Efficiency +90%",
 "salesAnim.checkPrice": "Price Compliance",
 "salesAnim.checkMarket": "Market Match",
 "salesAnim.checkTerms": "Terms Standard",
 "salesAnim.checkBrand": "Brand Consistent",
 "salesAnim.checkRisk": "Risk Flagged",
 "salesAnim.formal": "Formal Quotation",
 "salesAnim.standby": "Standby",
 "salesAnim.running": "Generating",
 "salesAnim.complete": "Completed",
 // Animation texts - Booking Worker
 "bookingAnim.carrierConnected": "Connected ",
 "bookingAnim.carriers": "+ Carriers",
 "bookingAnim.responseSpeed": "Response: ",
 "bookingAnim.predictionAccuracy": "Prediction Accuracy: ",
 "bookingAnim.todayHandled": "Today Handled: ",
 "bookingAnim.times": " times",
 "bookingAnim.exceptionResolved": "Exception Resolved",
 "bookingAnim.apiResponse": "API Response: 10ms/request",
 // Animation texts - Customs Worker
 "customsAnim.subtitle": "Intelligent Customs Compliance Automation",
 "customsAnim.processComplete": "Process Complete",
 "customsAnim.analyzing": "AI analyzing product description...",
 "customsAnim.product": "Product: Electronic Chip Module",
 "customsAnim.match": "Match",
 "customsAnim.processorController": "Processor & Controller",
 "customsAnim.todaySuggestions": "Today's Suggestions",
 "customsAnim.screeningEntities": "Screening entity list...",
 "customsAnim.noSanctionRisk": "No Sanction Risk",
 "customsAnim.crossVerified": "Multi-database cross-verification complete",
 "customsAnim.todayPassed": "Passed Today",
 "customsAnim.customsRegulations": "Customs Regulations",
 "customsAnim.import": "Import",
 "customsAnim.export": "Export",
 "customsAnim.comprehensiveAnalysis": "Comprehensive Compliance Analysis",
 "customsAnim.hsVerify": "HS Verify",
 "customsAnim.sanctionScreen": "Sanction Screen",
 "customsAnim.regulationMatch": "Regulation Match",
 "customsAnim.riskAssess": "Risk Assessment",
 "customsAnim.reportGenerated": "Compliance Report Generated",
 "customsAnim.autoCheckComplete": "Automated check complete",
 "customsAnim.riskLevel": "Risk Level",
 "customsAnim.low": "Low",
 "customsAnim.confidence": "Confidence",
 "customsAnim.timeTaken": "Time",
 "customsAnim.standby": "Standby",
 "customsAnim.completed": "Completed",
 "customsAnim.processing": "Processing",
 "customsAnim.step": "Step",
 "customsAnim.monitoring": "Real-time Monitoring",
 "customsAnim.waitingProcess": "Waiting to process...",
 // Animation texts - Document Worker
 "docAnim.recognizing": "Recognizing...",
 "docAnim.newTemplates": "Learned 2 new document formats",
 "docAnim.anomalyFixed": "Detected and fixed 1 anomaly",
 "docAnim.syncing": "Syncing...",
 "docAnim.bl": "B/L",
 "docAnim.productName": "Goods: Electronics",
 "docAnim.hsCode": "HS Code: 8471.30",
 "docAnim.weight": "Weight: 2,500 KG",
 "docAnim.pieces": "Pieces: 150 pcs",
 "docAnim.docCheck": "Document Check",
 "docAnim.packingQty": "Packing Qty:",
 "docAnim.correct": "150 pcs ✓",
 "docAnim.incorrect": "1500 pcs ✗",
 "docAnim.fmsSystem": "FMS System",
 "docAnim.syncedToFms": "Synced to FMS",
 "docAnim.templateBl": "B/L",
 "docAnim.templateInvoice": "Invoice",
 "docAnim.templatePacking": "Packing",
 "docAnim.templateCustoms": "Customs",
 "docAnim.templateOrigin": "Origin",
 "docAnim.accuracy": "Recognition Accuracy:",
 // Social Proof Section
 "socialProof.title": "Digital Proof",
 "socialProof.desc": "A Trusted Technology Partner",
 "socialProof.stat1": "Freight Forwarders Trust Us",
 "socialProof.stat2": "Quick Deployment",
 "socialProof.stat2Unit": "Months",
 "socialProof.stat3": "Native Architecture",
 "socialProof.stat4": "Southeast Asia Leader",
 "socialProof.certs": "Certifications",
 "socialProof.testimonial1.quote": "CargoNova completely transformed our rate management. What used to take hours now takes seconds, with even higher accuracy.",
 "socialProof.testimonial1.avatar": "O",
 "socialProof.testimonial1.name": "Operations Director",
 "socialProof.testimonial1.company": "Global Logistics Group",
 "socialProof.testimonial2.quote": "Digital workers process our documentation overnight. We wake up to handled shipments instead of piled-up paperwork.",
 "socialProof.testimonial2.avatar": "C",
 "socialProof.testimonial2.name": "Chief Executive Officer",
 "socialProof.testimonial2.company": "Pacific Freight Solutions",
 // Shipping Operations Section
 "shipping.title": "Smart Shipping Operations Center",
 "shipping.desc": "One-stop ocean/air freight operations platform, AI-powered logistics management",
 "shipping.crm.header.customer": "Customer",
 "shipping.crm.header.company": "Company",
 "shipping.crm.header.status": "Status",
 "shipping.crm.header.stage": "Stage",
 "shipping.crm.customer1": "Michael Li",
 "shipping.crm.company1": "Huawei Tech",
 "shipping.crm.status1": "VIP Client",
 "shipping.crm.stage1": "In Transit",
 "shipping.crm.customer2": "Frank Wang",
 "shipping.crm.company2": "Alibaba",
 "shipping.crm.status2": "Long-term",
 "shipping.crm.stage2": "Booking Ocean",
 "shipping.crm.customer3": "David Zhang",
 "shipping.crm.company3": "Tencent",
 "shipping.crm.status3": "New Client",
 "shipping.crm.stage3": "Air Quote Pending",
 "shipping.crm.customer4": "Steven Chen",
 "shipping.crm.company4": "BYD",
 "shipping.crm.status4": "VIP Client",
 "shipping.crm.stage4": "Delivered",
 "shipping.crm.title": "Shipment CRM",
 "shipping.crm.desc": "Manage ocean/air freight customers and orders in a centralized system with intelligent follow-up tracking.",
 "shipping.worker.sea": "Ocean AI Agent",
 "shipping.worker.seaRole": "Booking Agent",
 "shipping.worker.air": "Air AI Agent",
 "shipping.worker.airRole": "Document Reviewer",
 "shipping.worker.doc": "Document AI Agent",
 "shipping.worker.docRole": "Service Assistant",
 "shipping.worker.title": "AI Agent Management",
 "shipping.worker.desc": "Assign AI agent roles for different scenarios (booking/documentation/review) with real-time collaboration.",
 "shipping.resource.20ft": "20ft Container",
 "shipping.resource.40ft": "40ft Container",
 "shipping.resource.title": "Resource Booking",
 "shipping.resource.desc": "Book ocean/air cargo space and refrigerated containers across routes with real-time inventory display.",
 "shipping.scan.billTitle": "Bill of Lading",
 "shipping.scan.origin": "Origin: Shanghai",
 "shipping.scan.dest": "Dest: Los Angeles",
 "shipping.scan.title": "AI Document Scan",
 "shipping.scan.desc": "Scan B/L, AWB, packing lists via mobile, auto-recognize key info and sync to system.",
 "shipping.fee.title": "Fee Details",
 "shipping.fee.verified": "Verified",
 "shipping.fee.port": "Port Charges",
 "shipping.fee.insurance": "Insurance",
 "shipping.fee.transport": "Freight Cost",
 "shipping.fee.total": "Total",
 "shipping.fee.linked": "Auto-linked Order",
 "shipping.fee.cardTitle": "AI Fee Settlement",
 "shipping.fee.cardDesc": "Upload transport invoices in real-time, AI auto-recognizes and categorizes fees to generate settlement bills.",
 // AI Tech Section
 "ai.badge": "Core Tech · 60%+ AI Capability",
 "ai.title1": "AI-Powered",
 "ai.title2": "Smart Logistics Engine",
 "ai.subtitle": "Four core AI capabilities of CargoNova freight forwarding software, building next-gen smart logistics infrastructure",
 "ai.native.title": "AI Native Architecture",
 "ai.native.subtitle": "Native AI-Driven",
 "ai.native.desc": "From infrastructure to UX, fully AI-native design. Smart decisions, predictive analytics, adaptive learning.",
 "ai.native.h1": "Deep Learning Engine",
 "ai.native.h2": "Real-time Optimization",
 "ai.native.h3": "Natural Language",
 "ai.native.h4": "Predictive Analytics",
 "ai.native.statValue": "99.2%",
 "ai.native.statLabel": "Decision Accuracy",
 "ai.worker.title": "AI Agents",
 "ai.worker.subtitle": "AI Agents",
 "ai.worker.desc": "24/7 intelligent AI agents handling customs, booking, tracking automatically, freeing staff for high-value work",
 "ai.worker.h1": "Auto Customs",
 "ai.worker.h2": "Smart Booking",
 "ai.worker.h3": "Exception Handling",
 "ai.worker.h4": "Customer Service",
 "ai.worker.statValue": "85%",
 "ai.worker.statLabel": "Labor Saved",
 "ai.rpa.title": "RPA Automation",
 "ai.rpa.subtitle": "Process Automation Robot",
 "ai.rpa.desc": "End-to-end process automation, from data entry to reports, from system integration to email handling",
 "ai.rpa.h1": "Multi-system Integration",
 "ai.rpa.h2": "Auto Data Sync",
 "ai.rpa.h3": "Smart Workflows",
 "ai.rpa.h4": "Exception Alerts",
 "ai.rpa.statValue": "10x",
 "ai.rpa.statLabel": "Efficiency Boost",
 "ai.ocr.title": "Smart OCR",
 "ai.ocr.subtitle": "Intelligent Document Recognition",
 "ai.ocr.desc": "Deep learning OCR technology, instant recognition of B/L, invoices, packing lists with 99%+ accuracy",
 "ai.ocr.h1": "Multi-language",
 "ai.ocr.h2": "Table Extraction",
 "ai.ocr.h3": "Handwriting Recognition",
 "ai.ocr.h4": "Smart Classification",
 "ai.ocr.statValue": "99.5%",
 "ai.ocr.statLabel": "Recognition Accuracy",
 "ai.learnMore": "Learn More",
 "ai.cta": "Ready to experience AI-powered logistics?",
 "ai.ctaBtn": "Request Demo",
 // AI Architecture Card
 "ai.arch.badge": "AI Native Architecture",
 "ai.arch.title": "Smart Decision Engine",
 "ai.arch.layer1": "Business Layer",
 "ai.arch.layer1Sub": "Business Application",
 "ai.arch.layer1.i1": "Rate Query",
 "ai.arch.layer1.i2": "Booking Mgmt",
 "ai.arch.layer1.i3": "Track & Trace",
 "ai.arch.layer1.i4": "Billing",
 "ai.arch.layer2": "Worker Layer",
 "ai.arch.layer2Sub": "AI Agent",
 "ai.arch.layer2.i1": "Task Orchestration",
 "ai.arch.layer2.i2": "Process Automation",
 "ai.arch.layer2.i3": "Exception Handling",
 "ai.arch.layer2.i4": "Smart Scheduling",
 "ai.arch.layer3": "AI Foundation",
 "ai.arch.layer3Sub": "AI Foundation",
 "ai.arch.layer3.i1": "LLM",
 "ai.arch.layer3.i2": "OCR Engine",
 "ai.arch.layer3.i3": "Machine Learning",
 "ai.arch.layer3.i4": "Knowledge Graph",
 "ai.arch.dataFlow": "Real-time Data Flow",
 // Digital Employee Card
 "ai.emp.title": "Digital Employee",
 "ai.emp.status": "Online Ready",
 "ai.emp.booking": "Booking Process",
 "ai.emp.bookingBubble": "Auto-matching cabin resources",
 "ai.emp.bookingStats": "Today's bookings: ",
 "ai.emp.doc": "Document Review",
 "ai.emp.docBubble": "Smart recognition in progress...",
 "ai.emp.ocrRate": "OCR Accuracy 99.2%",
 // RPA Card
 "ai.rpaCard.title": "Process Automation",
 "ai.rpaCard.pipeline": "RPA Pipeline",
 "ai.rpaCard.bill": "B/L Data Entry",
 "ai.rpaCard.billBubble": "OCR Complete",
 "ai.rpaCard.billDone": " entered",
 "ai.rpaCard.cabin": "Carrier Space Sync",
 "ai.rpaCard.cabinBubble": "Space Locked",
 "ai.rpaCard.cabinDone": " locked",
 "ai.rpaCard.fee": "Port Fee Check",
 "ai.rpaCard.feeBubble": "Pushed to Settlement",
 "ai.rpaCard.feeDone": "Pushed to Settlement",
 "ai.rpaCard.complete": "RPA Process Complete",
 "ai.rpaCard.running": "Automation running...",
 "ai.rpaCard.order": "Order",
 "ai.rpaCard.misc": "Fees",
 "ai.rpaCard.diff": "Diff: 0",
 "ai.rpaCard.locked": "Space Locked",
 "ai.rpaCard.entered": "Entered: ",
 "ai.rpaCard.tickets": " tickets",
 // OCR Card
 "ai.ocrCard.title": "Document Recognition",
 "ai.ocrCard.system": "Booking System",
 "ai.ocrCard.upload": "Drag / Click to upload documents",
 "ai.ocrCard.uploadSub": "(B/L / Packing List)",
 "ai.ocrCard.file": "Bill_of_Lading.pdf",
 "ai.ocrCard.structure": "Structured Data",
 "ai.ocrCard.synced": "Synced to booking module",
 "ai.ocrCard.extracted": "Extracted",
 "ai.ocrCard.archived": "Archived",
 "ai.ocrCard.accuracy": "Recognition accuracy: ",
 "ai.ocrCard.field1": "Product Name",
 "ai.ocrCard.field1Val": "Electronics",
 "ai.ocrCard.field2": "HS Code",
 "ai.ocrCard.field2Val": "8542.31.00",
 "ai.ocrCard.field3": "Gross Weight",
 "ai.ocrCard.field3Val": "2,450 KG",
 "ai.ocrCard.field4": "Dest Port",
 "ai.ocrCard.field4Val": "Rotterdam",
 "ai.ocrCard.wait": "Waiting for document...",
 "ai.ocrCard.loading": "Loading document...",
 "ai.ocrCard.recognizing": "OCR recognizing...",
 "ai.ocrCard.extracting": "Extracting info...",
 "ai.ocrCard.syncing": "Syncing data...",
 "ai.ocrCard.complete": "Recognition complete",
 // Partners Section
 "partners.badge": "Partners",
 "partners.title": "Partners",
 "partners.desc": "Deep partnerships with top global shipping lines, airlines and tech companies for premium logistics services",
 "partners.shipping": "Shipping Partners",
 "partners.air": "Airline Partners",
 "partners.ports": "Ports Covered",
 "partners.countries": "Countries/Regions",
 // About Section
 "about.badge": "About Us",
 "about.title1": "Pioneering a ",
 "about.title2": "New Era",
 "about.title3": " in Smart Logistics",
 "about.imgAlt": "Smart Logistics professional team collaboration",
 "about.p1": "CargoNova is an AI-native freight forwarding platform by Deep Insights (Singapore), offering digital freight management solutions for forwarders across air, ocean, and multimodal operations. An intelligent sub-brand of Deep Insights, it integrates cutting-edge technologies including Large Language Models (LLM), RPA automation, and intelligent OCR to introduce a revolutionary AI Agent Matrix covering seven core modules: rate management, intelligent quotation, booking management, documentation processing, customs compliance, settlement audit, and risk management. Committed to the mission of 'Making Every Shipment Intelligently Operated', CargoNova supports multi-language, multi-currency, and multi-regulatory global deployment through cloud-native architecture, helping freight forwarders achieve 99.5% freight rate SLA, 98.2% booking success rate, and 99.8% documentation accuracy.",
 "about.p1Link": "https://en.deepinsights.com.cn/",
 "about.p2": "",
 "about.learnMoreDongyin": "Learn More About Deep Insights →",
 "about.stat1": "Founded",
 "about.stat2": "Team Members",
 "about.stat3": "Funding Rounds",
 "about.mission": "Mission",
 "about.missionDesc": "Reshape global logistics with AI technology, making every shipment smarter and more efficient",
 "about.vision": "Vision",
 "about.visionDesc": "Become the world's leading AI Native smart logistics platform, connecting every corner of the world",
 "about.values": "Values",
 "about.valuesDesc": "Innovation-driven, customer-first, integrity, pursuit of excellence",
 "about.team": "Team",
 "about.teamDesc": "Gathering top talents from AI, logistics, and technology to build a cross-disciplinary innovation team",
 "about.companyIntro": "Company Overview",
 "about.coreValues": "Core Values",
 "about.highlight1Title": "Integrated Cloud Platform",
 "about.highlight1Desc": "Five integrated cloud products: OMS, TMS, WMS, YMS, GTM",
 "about.highlight2Title": "Industry Digitalization",
 "about.highlight2Desc": "Three digital product lines for shipping, freight forwarding, and integrated logistics",
 "about.highlight3Title": "AI Intelligent Products",
 "about.highlight3Desc": "DI.AI supply chain intelligent products, CargoNova provides AI Native, AI Agents, integrating OR algorithms with LLMs",
 "about.highlight4Title": "Top Client Recognition",
 "about.highlight4Desc": "DHL, Sinotrans, Honour Lane Shipping, KORMAN INTERNATIONAL (Singapore, Hong Kong, Indonesia)",
 "about.companyData.title": "Company Data",
 "about.companyData.parentLabel": "Parent Company",
 "about.companyData.parentValue": "Deep Insights (洞隐科技)",
 "about.companyData.hqLabel": "Headquarters",
 "about.companyData.hqValue": "Singapore (Marina Bay Financial Centre)",
 "about.companyData.productLabel": "Core Product Lines",
 "about.companyData.productValue": "WMS Cloud, TMS Cloud, CargoNova",
 "about.ourNumbers.title": "Our Numbers",
 "about.ourNumbers.stat1Label": "Freight Forwarders Served",
 "about.ourNumbers.stat1Value": "600+",
 "about.ourNumbers.stat2Label": "Countries & Regions",
 "about.ourNumbers.stat2Value": "30+",
 "about.ourNumbers.stat3Label": "On-Time Delivery Rate",
 "about.ourNumbers.stat3Value": "99.5%",
 "about.parentCompanyText": "CargoNova is part of the Deep Insights product suite, alongside WMS Cloud and TMS Cloud.",
 "about.lastUpdated": "Last Updated: June 2026",
 "about.timeline": "Development History",
 "about.milestone2003_1": "Quantum Asia & Gillion Software founded",
 "about.milestone2003_2": "ERP software implementation",
 "about.milestone2003_3": "Developed SCM software for large logistics enterprises",
 "about.milestone2008_1": "Focused on supply chain execution software",
 "about.milestone2008_2": "Listed in Shanghai Hi-Tech Enterprise",
 "about.milestone2008_3": "Recognized as Shanghai Key Software Enterprise",
 "about.milestone2014_1": "Awarded National Hi-Tech Zone Top 100 Enterprise",
 "about.milestone2014_2": "Rebuilt SCM products with cloud architecture and microservices",
 "about.milestone2016_1": "Gillion Software completed Zhangjiang Century financing",
 "about.milestone2016_2": "Tuofeng acquired Zhangjiang Century shares",
 "about.milestone2016_3": "Quantum Asia received Yonyou strategic investment",
 "about.milestone2019_1": "Partnered with HUST, developed supply chain optimization products based on data and AI",
 "about.milestone2019_2": "Featured in Gartner TMS & WMS reports",
 "about.milestone2019_3": "Enhanced service middle platform applications",
 "about.milestone2022_1": "Deep Insights founded, completed Series A from Yinshan Capital",
 "about.newStat1": "Years of SCM Digitalization Experience",
 "about.newStat2": "Customer Deployments",
 "about.newStat3": "AI Agents",
 "about.newStat4": "Core R&D Team Members",
 "about.newStat5": "Enterprise Clients",
 "about.newStat6": "System Daily Active Users",
 // Contact Section
 "contact.badge": "Contact Us",
 "contact.title": "Ready to Transform Your Freight Business?",
 "contact.desc": "Join leading forwarders who have deployed AI agent matrices",
 "contact.help": "Need Help?",
 "contact.helpDesc": "Our AI assistant and professional team are available 24/7 to answer your questions",
 "contact.chat": "Live Chat",
 "contact.phone": "Phone",
 "contact.email": "Email",
 "contact.address": "Address",
 "contact.addressVal": "Lujiazui Financial Center, Pudong, Shanghai",
 "contact.hours": "Business Hours",
 "contact.hoursVal": "Mon-Fri 9:00-18:00",
 "contact.formTitle": "Send Message",
 "contact.name": "Name",
 "contact.namePh": "Your name",
 "contact.company": "Company",
 "contact.companyPh": "Company name",
 "contact.emailPh": "your@email.com",
 "contact.phonePh": "Phone number",
 "contact.message": "Message",
 "contact.messagePh": "Describe your requirements...",
 "contact.send": "Send Message",
 // CTA
 "cta.demo": "Book Demo",
 "cta.download": "Download Brochure",
 // Solutions Page
 "solutions.title": "Solutions",
 "solutions.subtitle": "A tailored freight forwarding system and freight forwarder platform for every type of forwarder",
 "solutions.painPointsTitle": "Pain Points",
 "solutions.painPointsSubtitle": "Common Business Challenges",
 "solutions.solutionsTitle": "How CargoNova Solves It",
 "solutions.solutionsSubtitle": "CargoNova Smart Solutions",
 "solutions.solutionsBadge": "Smart Solution",
 "solutions.improvementsTitle": "Expected Improvements",
 "solutions.whySuitable": "Why It's Perfect for You",
 "solutions.ctaDiagnosis": "Request Free Diagnosis",
 "solutions.tab1.label": "For S.E.Asia Local Forwarders",
 "solutions.tab1.hero": "Want to lead in digital competition as a S.E.Asia freight forwarder?",
 "solutions.tab1.heroSub": "CargoNova is the ERP platform designed for you",
 "solutions.tab1.pain1": "Systems too complex, high employee training costs",
 "solutions.tab1.pain2": "Competitors going digital while I'm stuck with Excel",
 "solutions.tab1.pain3": "S.E.Asia compliance regulations are complex and error-prone",
 "solutions.tab1.sol1": "Fully S.E.Asia-localized interface, as simple as WeChat",
 "solutions.tab1.sol2": "Built-in S.E.Asia e-Customs, compliance handled automatically",
 "solutions.tab1.sol3": "7 AI agents auto-quote, book, and reconcile",
 "solutions.tab1.imp1": "Operational Efficiency",
 "solutions.tab1.imp2": "System Launch",
 "solutions.tab1.imp3": "Staff Turnover",
 "solutions.tab1.impVal1": "↑ 300%",
 "solutions.tab1.impVal2": "3 Days",
 "solutions.tab1.impVal3": "↓ 50%",
 "solutions.tab1.why": "We're designed for Southeast Asian local businesses, fully understanding your pain points and workflows",
 "solutions.tab2.label": "For Chinese Overseas Enterprises",
 "solutions.tab2.hero": "Going global but branch data is chaotic?",
 "solutions.tab2.heroSub": "CargoNova is your global unified management platform",
 "solutions.tab2.pain1": "HQ can't see overseas branch operations clearly",
 "solutions.tab2.pain2": "Branch data never reconciles",
 "solutions.tab2.pain3": "Complex reporting processes, slow decisions",
 "solutions.tab2.sol1": "HQ sees all branch data in real-time",
 "solutions.tab2.sol2": "One system, multi-country, auto-switching interface",
 "solutions.tab2.sol3": "Flexibility for frontline, control for HQ",
 "solutions.tab2.imp1": "Business Growth",
 "solutions.tab2.imp2": "Labor Cost Increase",
 "solutions.tab2.imp3": "Reconciliation Cycle",
 "solutions.tab2.impVal1": "2-3x",
 "solutions.tab2.impVal2": "< 20%",
 "solutions.tab2.impVal3": "↓ 85%",
 "solutions.tab2.why": "Our 7 AI agents help you unify global branch management and eliminate data silos",
 "solutions.tab3.label": "For Global Forwarders",
 "solutions.tab3.hero": "Business growing fast but cost pressure mounting?",
 "solutions.tab3.heroSub": "CargoNova lets you do 3x work with half the people",
 "solutions.tab3.pain1": "Double business means double hiring, profits eaten away",
 "solutions.tab3.pain2": "System bottlenecks and labor costs crushing together",
 "solutions.tab3.pain3": "Need fast and stable digital solutions",
 "solutions.tab3.sol1": "Let your 60-person team do 150-person work",
 "solutions.tab3.sol2": "Directly improve margins (salary costs from 40% → 15%)",
 "solutions.tab3.sol3": "Fast deployment (3 months), immediate results",
 "solutions.tab3.imp1": "Efficiency",
 "solutions.tab3.imp2": "Profit Margin",
 "solutions.tab3.imp3": "Go-Live Time",
 "solutions.tab3.impVal1": "↑ 250%",
 "solutions.tab3.impVal2": "↑ 13%",
 "solutions.tab3.impVal3": "3 Months",
 "solutions.tab3.why": "Our rapid deployment capability solves your 'grow fast while controlling costs' dilemma",
 // Customers Page
 "customers.pageTitle": "Customer Success Stories",
    "customers.pageSubtitle": "See how freight forwarders transform with CargoNova",
    "customers.caseStudiesHeading": "Customer Success Stories",
 "customers.metricsTitle": "Customer Success Metrics",
 "customers.metric1": "Trusted Companies",
 "customers.metric2": "Months to Go-Live",
 "customers.metric3": "Efficiency Boost",
 "customers.metric4": "Continuous Ops",
 "customers.challengeLabel": "Challenge",
 "customers.solutionLabel": "Solution",
 "customers.resultsLabel": "Results",
 "customers.testimonialsTitle": "What Our Customers Say",
 "customers.ctaTitle": "Ready to Write Your Success Story?",
 "customers.ctaSubtitle": "Join the leading forwarders who have deployed digital workforce",
 "customers.case1.type": "S.E.Asia Local Forwarder",
 "customers.case1.company": "Leading S.E.Asia Freight Co.",
 "customers.case1.challenge": "Complex systems with high training costs, competitors digitalizing while still using Excel",
 "customers.case1.solution": "Deployed 7 AI agents, multi-language interface, built-in S.E.Asia e-Customs compliance",
 "customers.case1.result1": "Operational Efficiency",
 "customers.case1.result2": "Days to Go-Live",
 "customers.case1.result3": "Staff Turnover",
 "customers.case1.quote": "CargoNova transformed our operations overnight. The localized interface made onboarding effortless.",
 "customers.case2.type": "Chinese Global Enterprise",
 "customers.case2.company": "Global Trade Solutions",
 "customers.case2.challenge": "HQ couldn't see overseas branch operations, data never aligned across branches",
 "customers.case2.solution": "Unified global management platform, real-time visibility for HQ across all branches",
 "customers.case2.result1": "Business Growth",
 "customers.case2.result2": "Labor Cost Increase",
 "customers.case2.result3": "Reconciliation Cycle",
 "customers.case2.quote": "Finally we can see all branch data in real-time. Decision-making became instant and efficient.",
 "customers.case3.type": "For Global Forwarders",
 "customers.case3.company": "Global Freight Partners",
 "customers.case3.challenge": "Rapid growth with huge cost pressure, doubling business meant doubling headcount",
 "customers.case3.solution": "Digital workers tripled team output, directly improving profit margins",
 "customers.case3.result1": "Efficiency",
 "customers.case3.result2": "Profit Margin",
 "customers.case3.result3": "Months to Go-Live",
 "customers.case3.quote": "Profit margin went from 12% to 28%. The ROI was immediate.",
 "customers.testimonial1.quote": "CargoNova completely transformed our rate management. What used to take hours now takes seconds, with higher accuracy.",
 "customers.testimonial1.author": "Operations Director",
 "customers.testimonial1.company": "Global Logistics Group",
 "customers.testimonial2.quote": "Digital workers process our documents overnight. We wake up to processed shipments, not piles of paperwork.",
 "customers.testimonial2.author": "CEO",
 "customers.testimonial2.company": "Pacific Freight Solutions",
 // Footer
 "footer.slogan": "AI Native smart logistics platform, connecting the world with technology",
 "footer.services": "Services",
 "footer.services.1": "Ocean Freight",
 "footer.services.2": "Air Freight",
 "footer.services.3": "Smart Pricing",
 "footer.services.4": "Smart Settlement",
 "footer.tech": "Technology",
 "footer.tech.1": "AI Native",
 "footer.tech.2": "AI Agents",
 "footer.tech.3": "RPA Automation",
 "footer.tech.4": "Smart OCR",
 "footer.company": "Company",
 "footer.company.1": "About Us",
 "footer.company.2": "Partners",
 "footer.company.3": "News",
 "footer.company.4": "Careers",
 "footer.support": "Support",
 "footer.support.1": "Help Center",
 "footer.support.2": "API Docs",
 "footer.support.3": "Contact Us",
 "footer.support.4": "Privacy Policy",
 "footer.deepInsightsTagline": "Powered by Deep Insights",
 "footer.copyright": "© 2025-2026 Deep Insights., All rights reserved.",
 "footer.terms": "Terms of Service",
 "footer.privacy": "Privacy Policy",
 "footer.cookies": "Cookie Settings",
 },
 th: {
 // Navbar
    "nav.home": "หน้าแรก",
    "nav.solutions": "โซลูชัน",
    "nav.digitalWorkers": "AI Agents",
    "nav.cases": "กรณีศึกษา",
    "nav.about": "เกี่ยวกับเรา",
    "nav.faq": "คำถามที่พบบ่อย",
    "nav.consult": "ติดต่อเรา",
    "nav.faq.whatIs": "CargoNova คืออะไร",
    "nav.faq.compare": "CargoNova vs CargoWise",
    "nav.faq.aiAgents": "AI Agents",
    "nav.faq.pricing": "ราคาและค่าบริการ",
    "nav.faq.implementation": "การวางระบบและย้ายข้อมูล",
    "nav.brand": "อัจฉริยะ",
    "nav.brandHighlight": "โลจิสติกส์",
 // Hero
 "hero.badge": "ขับเคลื่อนด้วยระบบ AI-Native ตั้งแต่ต้นจนจบกระบวนการ",
 "hero.title1": "AI Native + AI Agents, ",
 "hero.title2": "นิยามใหม่ของประสิทธิภาพการส่งต่อสินค้า",
 "hero.title3": "",
 "hero.desc": "CargoNova AI — ซอฟต์แวร์ฟอร์เวิร์ดเดอร์ AI-Native โดย Deep Insights นิยามใหม่ของโลจิสติกส์ระหว่างประเทศตั้งแต่ต้นจนจบ",
 "hero.cta1": "เริ่มต้นใช้งาน",
 "hero.cta2": "ดูวิดีโอสาธิต",
 "hero.stat1Value": "99.5%",
 "hero.stat1Label": "อัตราการทำตาม SLA",
 "hero.stat2Value": "98.2%",
 "hero.stat2Label": "อัตราความสำเร็จในการจอง",
 "hero.stat3Value": "99.8%",
 "hero.stat3Label": "ความถูกต้องของเอกสาร",
 // Services Section
 "services.badge": "ทำไมต้อง CargoNova",
 "services.title": "ทำไมต้องเลือก CargoNova",
 "services.desc": "สร้างขึ้นเพื่ออนาคตของการส่งต่อสินค้าระหว่างประเทศ",
 "services.shipping.title": "ดีเอ็นเอแบบ AI Native + Cloud Native",
 "services.shipping.desc": "การออกแบบโดยเน้น AI เป็นหลักตั้งแต่เริ่มต้น ไม่ใช่การดัดแปลงในภายหลัง สถาปัตยกรรมระดับ Cloud-native ที่แท้จริงช่วยให้รองรับการขยายตัวได้อย่างไร้ขีดจำกัดและไม่ต้องบำรุงรักษา",
 "services.shipping.f1": "การออกแบบโดยเน้น AI เป็นหลัก",
 "services.shipping.f2": "รองรับการขยายตัวอย่างไร้ขีดจำกัด",
 "services.shipping.f3": "ไม่ต้องบำรุงรักษา",
 "services.air.title": "โครงข่าย AI Agent",
 "services.air.desc": "AI agent เฉพาะทางหลายตัวทำงานร่วมกันได้อย่างราบรื่น ช่วยจัดการอัตราค่าบริการ การจอง เอกสาร และพิธีการศุลกากรทั่วทั้งการดำเนินงานของคุณ",
 "services.air.f1": "การสอบถามอัตราค่าบริการ",
 "services.air.f2": "การจองและเอกสาร",
 "services.air.f3": "กระบวนการพิธีการศุลกากร",
 "services.pricing.title": "พร้อมใช้งานทั่วโลก",
 "services.pricing.desc": "รองรับหลายภาษา หลายสกุลเงิน และกฎระเบียบที่หลากหลายในตัว เริ่มต้นใช้งานได้ทั่วโลกพร้อมการปฏิบัติตามกฎระเบียบในท้องถิ่นตั้งแต่วันแรก",
 "services.pricing.f1": "รองรับหลายภาษา",
 "services.pricing.f2": "รองรับหลายสกุลเงิน",
 "services.pricing.f3": "รองรับหลากหลายกฎระเบียบ",
 "services.settlement.title": "การผสานรวมที่ราบรื่น",
 "services.settlement.desc": "ระบบอัตโนมัติแบบวงปิด เห็น-คำนวณ-บันทึก เชื่อมต่อกับระบบเดิมได้ทุกระบบโดยไม่ต้องใช้ API พนักงานดิจิทัลช่วยเชื่อมช่องว่างระหว่างระบบเก่าและระบบใหม่ได้อย่างราบรื่น",
 "services.settlement.f1": "ระบบอัตโนมัติแบบวงปิด",
 "services.settlement.f2": "ไม่ต้องใช้ API",
    "services.settlement.f3": "การผสานรวมกับระบบเดิม",
    "services.learnMore": "สำรวจโซลูชัน",
    "services.compareLink": "CargoNova ปะทะ CargoWise",
    // AI Agent Showcase
 "digitalWorker.badge": "AI Agents",
 "digitalWorker.title": "ทีม AI Agent ส่วนตัวของคุณ",
 "digitalWorker.desc": "คุณไม่ได้แค่ซื้อระบบ แต่คุณกำลังจ้างพนักงานระดับท็อป 7 คน",
 // Module Showcase - NovaQuote
 "module.quote.title": "NovaSales",
 "module.quote.subtitle": "ผู้เชี่ยวชาญการเสนอราคาหลายรูปแบบ",
 "module.quote.f1": "เสนอราคาใน 2 นาที",
 "module.quote.f2": "เปรียบเทียบหลากหลายรูปแบบ",
 "module.quote.f3": "แนะนำอย่างชาญฉลาด",
 "module.quote.d1": "วิเคราะห์ข้อมูลคำขอราคาลูกค้าอัตโนมัติ",
 "module.quote.d2": "เปรียบเทียบราคาจากผู้ให้บริการขนส่งหลายราย",
 "module.quote.d3": "ปรับอัตรากำไรให้เหมาะสมอย่างชาญฉลาด",
 "module.quote.d4": "สร้างใบเสนอราคาได้ในคลิกเดียว",
 // Module Showcase - NovaRate
 "module.rate.title": "NovaRate",
 "module.rate.subtitle": "ระบบจัดการอัตราค่าระวางให้คุ้มค่าที่สุด",
 "module.rate.f1": "วิเคราะห์สัญญา",
 "module.rate.f2": "ดัชนีราคา",
 "module.rate.f3": "ระบบตรวจสอบ SLA",
 "module.rate.d1": "วิเคราะห์อัตราค่าระวางตามสัญญาอัตโนมัติ",
 "module.rate.d2": "รวบรวมข้อมูลราคาตลาดแบบเรียลไทม์",
 "module.rate.d3": "กลยุทธ์การเสนอราคาที่ชาญฉลาด",
 "module.rate.d4": "แจ้งเตือนอัตราค่าระวางตาม SLA",
 // Module Showcase - NovaBook
 "module.book.title": "NovaBook",
 "module.book.subtitle": "ผู้ประสานงานการจองระบบขนส่ง",
 "module.book.f1": "เชื่อมตรงผู้ให้บริการขนส่ง",
 "module.book.f2": "คาดการณ์พื้นที่ระวาง",
 "module.book.f3": "จัดการข้อยกเว้น",
 "module.book.d1": "เชื่อมต่อตรงกับ API ของผู้ให้บริการขนส่ง",
 "module.book.d2": "เชื่อมต่อกับผู้ให้บริการขนส่งดิจิทัล",
 "module.book.d3": "คาดการณ์พื้นที่ระวางอย่างชาญฉลาด",
 "module.book.d4": "จัดการข้อยกเว้นอัตโนมัติ",
 // Module Showcase - NovaDocs
 "module.docs.title": "NovaDocs",
 "module.docs.subtitle": "ผู้ควบคุมดูแลเอกสาร",
 "module.docs.f1": "การจดจำอักขระด้วยแสง (OCR)",
 "module.docs.f2": "การเรียนรู้เทมเพลต",
 "module.docs.f3": "การซิงก์ FMS",
 "module.docs.d1": "การจดจำอัจฉริยะด้วย OCR+LLM",
 "module.docs.d2": "การเรียนรู้ด้วยตัวเองของเทมเพลต",
 "module.docs.d3": "การตรวจจับความผิดปกติอัตโนมัติ",
 "module.docs.d4": "ซิงก์ FMS ในคลิกเดียว",
 // Module Showcase - NovaCustoms
 "module.customs.title": "NovaCustoms",
 "module.customs.subtitle": "ที่ปรึกษาด้านการปฏิบัติตามข้อกำหนด",
 "module.customs.f1": "พิกัดอัตราศุลกากร (HS Code)",
 "module.customs.f2": "การคัดกรองมาตรการคว่ำบาตร",
 "module.customs.f3": "กราฟความสัมพันธ์กฎระเบียบ",
 "module.customs.d1": "คำแนะนำพิกัด HS Code โดย AI",
 "module.customs.d2": "การคัดกรองมาตรการคว่ำบาตรแบบเรียลไทม์",
 "module.customs.d3": "กราฟความรู้เกี่ยวกับกฎระเบียบศุลกากร",
 "module.customs.d4": "การตรวจสอบการปฏิบัติตามข้อกำหนดอัตโนมัติ",
 // Module Showcase - NovaFinance
 "module.finance.title": "NovaFinance",
 "module.finance.subtitle": "เครื่องมือตรวจสอบการชำระเงิน",
 "module.finance.f1": "การกระทบยอดอัตโนมัติ",
 "module.finance.f2": "ระบบทวงถามยอดค้างชำระอัจฉริยะ",
 "module.finance.f3": "การเพิ่มประสิทธิภาพ DSO",
 "module.finance.d1": "การกระทบยอดใบแจ้งหนี้อัตโนมัติ",
 "module.finance.d2": "การจัดกลุ่มและแจ้งเตือนส่วนต่างอัจฉริยะ",
 "module.finance.d3": "เวิร์กโฟลว์การเรียกเก็บเงินอัตโนมัติ",
 "module.finance.d4": "การเพิ่มประสิทธิภาพรอบระยะเวลาเรียกเก็บหนี้ (DSO)",
 // Module Showcase - NovaRisk
 "module.risk.title": "NovaRisk",
 "module.risk.subtitle": "ระบบควบคุมความเสี่ยง",
 "module.risk.f1": "การตรวจสอบตลอดทั้งห่วงโซ่",
 "module.risk.f2": "การแจ้งเตือนความเสี่ยง",
 "module.risk.f3": "การให้คะแนนอัจฉริยะ",
 "module.risk.d1": "การตรวจสอบการดำเนินธุรกิจแบบครบวงจร",
 "module.risk.d2": "การแจ้งเตือนความเสี่ยงแบบเรียลไทม์",
 "module.risk.d3": "การประเมินคะแนนความเสี่ยงอัจฉริยะ",
 "module.risk.d4": "รายงานการตรวจสอบการปฏิบัติตามข้อกำหนด",
 // Module Demo Animations
 "demo.quote.agent": "Nova · Rate Expert",
 "demo.quote.request": "ใบเสนอราคาค่าระวางเรือจากเซี่ยงไฮ้ไปยังลอสแอนเจลิส (LA)",
 "demo.quote.task1": "กำลังดึงข้อมูลอัตราล่าสุด...",
 "demo.quote.task2": "กำลังคำนวณค่าธรรมเนียมเพิ่มเติม...",
 "demo.quote.task3": "กำลังวิเคราะห์ค่ากำหนดที่ต้องการ...",
 "demo.quote.task4": "กำลังสร้างใบเสนอราคา...",
 "demo.quote.savedTime": "เวลาที่ประหยัดได้",
 "demo.quote.priceTrend": "แนวโน้มราคา",
 "demo.quote.accuracy": "ความแม่นยำ",
 "demo.quote.complete": "วิเคราะห์เสร็จสิ้น",
 "demo.quote.recommend": "แนะนำ",
 "demo.rate.agent": "Nova · Rate Analyst",
 "demo.rate.request": "สอบถามแผนอัตราค่าระวางที่ดีที่สุด SHA → LAX",
 "demo.rate.task1": "กำลังรวบรวมอัตราค่าระวางจากหลายแพลตฟอร์ม...",
 "demo.rate.task2": "กำลังวิเคราะห์แนวโน้มราคา...",
 "demo.rate.task3": "กำลังประเมินพื้นที่ระวางและการขนส่ง...",
 "demo.rate.task4": "กำลังสร้างแผนการขนส่งที่ดีที่สุด...",
 "demo.rate.savedTime": "ประหยัดเวลาได้",
 "demo.rate.priceTrend": "แนวโน้มอัตราค่าระวาง",
 "demo.rate.accuracy": "ความแม่นยำของใบเสนอราคา",
 "demo.rate.margin": "เพิ่มประสิทธิภาพอัตรากำไร",
 "demo.rate.complete": "สร้างแผนการขนส่งที่ดีที่สุดแล้ว",
 "demo.rate.result": "เที่ยวเรือ",
 "demo.book.agent": "Nova · Booking Expert",
 "demo.book.request": "ต้องการจอง: SHA → LAX, 2x40GP",
 "demo.book.reply1": "พบพื้นที่ว่าง 3 รายการ แนะนำเที่ยวเรือ MSC วันที่ 5/20",
 "demo.book.confirm": "ยืนยัน MSC",
 "demo.book.reply2": "จองสำเร็จแล้ว! Space ID: MSC2024520A",
 "demo.book.successRate": "อัตราความสำเร็จในการจอง",
 "demo.docs.agent": "Nova · Document Expert",
 "demo.docs.todayCount": "ประมวลผลแล้ววันนี้",
 "demo.docs.processing": "กำลังประมวลผล",
 "demo.docs.ocrRecognizing": "กำลังจดจำข้อมูลด้วย OCR",
 "demo.docs.fieldExtract": "กำลังดึงข้อมูลฟิลด์",
 "demo.docs.formatCheck": "กำลังตรวจสอบรูปแบบ",
 "demo.docs.complete": "กระบวนการเสร็จสิ้น",
 "demo.docs.accuracy": "ความแม่นยำ",
 "demo.customs.agent": "Nova · Compliance Expert",
 "demo.customs.hsCode": "การตรวจสอบรหัส HS Code",
 "demo.customs.sanction": "การคัดกรองมาตรการคว่ำบาตร",
 "demo.customs.origin": "หนังสือรับรองถิ่นกำเนิดสินค้า",
 "demo.customs.license": "การตรวจสอบใบอนุญาต",
 "demo.customs.riskRate": "อัตราการสกัดกั้นความเสี่ยง",
 "demo.finance.agent": "Nova · Settlement Expert",
 "demo.finance.reconciledAmount": "ยอดเงินที่กระทบยอดแล้ว",
 "demo.finance.task1": "กำลังตรวจสอบใบแจ้งหนี้ค่าขนส่ง...",
 "demo.finance.task2": "กำลังจับคู่รายละเอียดค่าธรรมเนียม...",
 "demo.finance.task3": "กำลังกำกับรายการทีแตกต่าง...",
 "demo.finance.task4": "กำลังสร้างรายงานการกระทบยอด...",
 "demo.finance.invoiceTrend": "แนวโน้มการกระทบยอด",
 "demo.finance.matchRate": "อัตราการจับคู่",
 "demo.finance.dsoOptimize": "การเพิ่มประสิทธิภาพ DSO",
 "demo.finance.complete": "ดำเนินการกระทบยอดเสร็จสิ้น",
 "demo.finance.saved": "พบรายการทีแตกต่างและได้รับการกำกับแล้ว",
 "demo.risk.agent": "Nova · ผู้เชี่ยวชาญด้านความเสี่ยง",
 "demo.risk.handledAlerts": "จัดการการแจ้งเตือนแล้ว",
 "demo.risk.task1": "กำลังสแกนหาความผิดปกติของคำสั่งซื้อ...",
 "demo.risk.task2": "กำลังประเมินความเสี่ยงด้านเครดิต...",
 "demo.risk.task3": "กำลังตรวจสอบสถานะการปฏิบัติตามข้อกำหนด...",
 "demo.risk.task4": "กำลังสร้างรายงานความเสี่ยง...",
 "demo.risk.alertTrend": "แนวโน้มความเสี่ยง",
 "demo.risk.blockRate": "อัตราการบล็อก",
 "demo.risk.riskScore": "คะแนนความเสี่ยง",
 "demo.risk.complete": "ตรวจสอบความเสี่ยงเสร็จสิ้น",
 "demo.risk.result": "พบความเสี่ยงระดับปานกลาง 2 รายการ ดำเนินการแก้ไขอัตโนมัติแล้ว",
 "demo.days": "วัน",
 "demo.responseSpeed": "ความเร็วในการตอบสนอง",
 "demo.quoteTrend": "แนวโน้มการเสนอราคา",
 "demo.quoteAccuracy": "ความถูกต้องของการเสนอราคา",
 "demo.marginOptimize": "การเพิ่มประสิทธิภาพอัตรากำไร",
 "demo.optimalPlanGenerated": "สร้างแผนงานที่ดีที่สุดแล้ว",
 "demo.book.module1": "ค้นหาเส้นทาง",
 "demo.book.module2": "ยืนยันพื้นที่ระวาง",
 "demo.book.module3": "ส่งการจอง",
 "demo.book.stat1": "เส้นทางที่พร้อมใช้งาน",
 "demo.book.stat2": "การตอบสนองเฉลี่ย",
 "demo.book.stat3": "อัตราความสำเร็จ",
 "demo.book.todayBooking": "การจองวันนี้",
 "demo.book.successRateLabel": "อัตราความสำเร็จ",
 "demo.book.unit": "คำสั่งซื้อ",
 "demo.docs.progressLabel": "ความคืบหน้า",
 "demo.docs.efficiency": "ประสิทธิภาพ",
 "demo.docs.trendLabel": "แนวโน้มรอบ 7 วัน",
 "demo.docs.speed": "ความเร็ว",
 "demo.docs.speedUnit": "วินาที/หน้า",
 "demo.docs.accuracyLabel": "ความแม่นยำในการแยกแยะข้อมูล",
 "demo.customs.complianceTrend": "แนวโน้มการปฏิบัติตามข้อกำหนด",
 "demo.customs.todayCheck": "การตรวจสอบวันนี้",
 "demo.finance.arTrend": "แนวโน้ม AR",
 "demo.finance.dsoReduction": "การลดจำนวนวันรอรับชำระหนี้ (DSO)",
 "demo.finance.completed": "เสร็จสิ้น",
 "demo.finance.waiting": "รอดำเนินการ",
 "demo.risk.monitoring": "การติดตามความเสี่ยงแบบเรียลไทม์...",
 "demo.risk.alertsHandled": "จัดการการแจ้งเตือนแล้ว",
 "demo.risk.riskTrend": "แนวโน้มความเสี่ยง",
 "demo.risk.riskReduction": "การลดความเสี่ยง",
 "demo.risk.levelLow": "ต่ำ",
 "demo.risk.levelMedium": "ปานกลาง",
 "demo.risk.levelHigh": "สูง",
 "demo.status.working": "กำลังทำงาน",
 "demo.status.idle": "สแตนด์บาย",
 "demo.status.complete": "เสร็จสมบูรณ์",
 // Worker Cards
 "workerCard.rate.name": "NovaRate",
 "workerCard.rate.role": "ตัวเพิ่มประสิทธิภาพอัตราค่าระวาง",
 "workerCard.rate.ability": "เพิ่มประสิทธิภาพมาร์จินใบเสนอราคาโดยอัตโนมัติ",
 "workerCard.rate.roi": "มาร์จิน 5-10%",
 "workerCard.quote.name": "NovaSales",
 "workerCard.quote.role": "ผู้เชี่ยวชาญการทำหลายใบเสนอราคาพร้อมกัน",
 "workerCard.quote.ability": "สร้างใบเสนอราคาภายใน 2 นาที",
 "workerCard.quote.roi": "ความเร็ว 60x",
 "workerCard.book.name": "NovaBook",
 "workerCard.book.role": "ผู้ประสานงานการจอง",
 "workerCard.book.ability": "จองกับผู้ให้บริการขนส่งโดยอัตโนมัติ",
 "workerCard.book.roi": "ประสิทธิภาพ 300%",
 "workerCard.docs.name": "NovaDocs",
 "workerCard.docs.role": "ผู้ดูแลตรวจสอบเอกสาร",
 "workerCard.docs.ability": "จดจำและตรวจสอบโดยอัตโนมัติ",
 "workerCard.docs.roi": "อัตราข้อผิดพลาด 0.1%",
 "workerCard.customs.name": "NovaCustoms",
 "workerCard.customs.role": "ที่ปรึกษาด้านการปฏิบัติตามข้อกำหนด",
 "workerCard.customs.ability": "ตรวจสอบการปฏิบัติตามข้อกำหนดโดยอัตโนมัติ",
 "workerCard.customs.roi": "ความเสี่ยงด้านการปฏิบัติตามข้อกำหนด 95%",
 "workerCard.finance.name": "NovaFinance",
 "workerCard.finance.role": "ผู้ตรวจสอบบัญชีการชำระเงิน",
 "workerCard.finance.ability": "กระทบยอดและเรียกเก็บเงินโดยอัตโนมัติ",
 "workerCard.finance.roi": "DSO 20%",
 "workerCard.risk.name": "NovaRisk",
 "workerCard.risk.role": "ผู้ควบคุมความเสี่ยง",
 "workerCard.risk.ability": "การแจ้งเตือนแบบครอบคลุมต้นทางถึงปลายทาง",
 "workerCard.risk.roi": "ความเสี่ยง 95%",
 // Rate Worker
  "rateWorker.title": "NovaRate",
  "rateWorker.subtitle": "ระบบจัดการอัตราค่าบริการประสิทธิภาพสูง",
 "rateWorker.desc": "ผู้เชี่ยวชาญด้านการจัดการอัตราค่าขนส่งอัจฉริยะ วิเคราะห์สัญญาโดยอัตโนมัติ รวบรวมราคาตลาด สร้างกลยุทธ์การเสนอราคา และตรวจสอบ SLA",
 "rateWorker.h1": "การวิเคราะห์และจัดทำดัชนีอัตราค่าบริการตามสัญญา",
 "rateWorker.h2": "การรวบรวมอัตราค่าบริการในตลาดแบบเรียลไทม์",
 "rateWorker.h3": "กลยุทธ์การเสนอราคาอัจฉริยะ",
 "rateWorker.h4": "การตรวจสอบและแจ้งเตือน SLA ของอัตราค่าบริการ",
 "rateWorker.statValue": "99.5%",
 "rateWorker.statLabel": "อัตราการบรรลุเป้าหมาย SLA ของอัตราค่าบริการ",
 // Booking Worker
  "bookingWorker.title": "NovaBook",
  "bookingWorker.subtitle": "ผู้ประสานงานการจองระวาง",
 "bookingWorker.desc": "ผู้เชี่ยวชาญด้านการจองระวางอัจฉริยะ เชื่อมต่อกับสายการเดินเรือและสายการบินโดยตรง รวม API ของผู้รับจัดการขนส่งสินค้า คาดการณ์พื้นที่ระวาง และจัดการข้อยกเว้นโดยอัตโนมัติ",
 "bookingWorker.h1": "การเชื่อมต่อโดยตรงกับผู้ให้บริการขนส่ง",
 "bookingWorker.h2": "API สำหรับ NVOCC และผู้รับจัดการขนส่งสินค้าดิจิทัล",
 "bookingWorker.h3": "การคาดการณ์พื้นที่ระวางสินค้า",
 "bookingWorker.h4": "การจัดการข้อยกเว้นอัตโนมัติ",
 "bookingWorker.statValue": "98.2%",
 "bookingWorker.statLabel": "อัตราความสำเร็จในการจองระวาง",
 // Document Worker
  "documentWorker.title": "NovaDocs",
  "documentWorker.subtitle": "ผู้ดูแลจัดการเอกสาร",
 "documentWorker.desc": "ผู้เชี่ยวชาญด้านเอกสารอัจฉริยะ ผสานรวม OCR และ LLM เพื่อการตรวจจับข้อมูลอย่างอัจฉริยะ เรียนรู้เทมเพลตได้ด้วยตัวเอง ตรวจจับสิ่งผิดปกติ และซิงค์ข้อมูลกับ FMS ได้ในคลิกเดียว",
 "documentWorker.h1": "การตรวจจับและวิเคราะห์ด้วย OCR + LLM",
 "documentWorker.h2": "ระบบการเรียนรู้เทมเพลตด้วยตนเอง",
 "documentWorker.h3": "การตรวจสอบความผิดปกติ",
 "documentWorker.h4": "การซิงค์กับ FMS ด้วยคลิกเดียว",
 "documentWorker.statValue": "99.8%",
 "documentWorker.statLabel": "ความถูกต้องแม่นยำของเอกสาร",
 // Customs Worker
  "customsWorker.title": "NovaCustoms",
  "customsWorker.subtitle": "ที่ปรึกษาด้านการปฏิบัติตามข้อกำหนด",
 "customsWorker.desc": "ผู้เชี่ยวชาญด้านการผ่านพิธีการศุลกากรและการปฏิบัติตามกฎระเบียบอัจฉริยะ แนะนำพิกัดอัตราศุลกากร (HS Code) ด้วย AI คัดกรองรายชื่อผู้ถูกคว่ำบาตรแบบเรียลไทม์ เชื่อมโยงฐานข้อมูลกฎระเบียบศุลกากร และตรวจสอบการปฏิบัติตามข้อกำหนดโดยอัตโนมัติ",
 "customsWorker.h1": "คำแนะนำพิกัดศุลกากร (HS Code) โดย AI",
 "customsWorker.h2": "การคัดกรองรายชื่อผู้ถูกคว่ำบาตร",
 "customsWorker.h3": "คลังข้อมูลกฎระเบียบศุลกากรแบบเชื่อมโยง",
 "customsWorker.h4": "การตรวจสอบการปฏิบัติตามข้อกำหนดโดยอัตโนมัติ",
 "customsWorker.statValue": "100%",
 "customsWorker.statLabel": "อัตราการปฏิบัติตามกฎระเบียบที่ถูกต้อง",
 // Sales Worker (NovaSales)
 "salesWorker.title": "NovaSales",
 "salesWorker.subtitle": "ผู้เชี่ยวชาญด้านการเสนอราคาด้วย AI",
 "salesWorker.desc": "NovaSales คือ AI Agent ด้านการเสนอราคาของ CargoNova ที่เปรียบเทียบเรทแบบเรียลไทม์ สร้างใบเสนอราคาสมบูรณ์อัตโนมัติภายในไม่กี่วินาที และแสดงผลเป็นใบเสนอราคาอย่างเป็นทางการที่เป็นมาตรฐานและมืออาชีพ",
 "salesWorker.h1": "การสร้างใบเสนอราคาด้วย AI",
 "salesWorker.h2": "ยกระดับประสิทธิภาพ",
 "salesWorker.h3": "ใบเสนอราคาแบบมืออาชีพ",
 "salesWorker.h4": "ตรวจสอบความสอดคล้องตามข้อกำหนดแล้ว",
 "salesWorker.statValue": "90%+",
 "salesWorker.statLabel": "ประสิทธิภาพที่เพิ่มขึ้น",
 // Animation texts - Sales Worker
 "salesAnim.subtitle": "สร้างใบเสนอราคาอย่างเป็นทางการด้วย AI ในคลิกเดียว",
 "salesAnim.phase1": "การสร้างใบเสนอราคาด้วย AI",
 "salesAnim.phase2": "ยกระดับประสิทธิภาพ",
 "salesAnim.phase3": "ใบเสนอราคาแบบมืออาชีพ",
 "salesAnim.needsInput": "อินพุตความต้องการของลูกค้า",
 "salesAnim.tagBiz": "ประเภทธุรกิจ",
 "salesAnim.tagParams": "ข้อกำหนด",
 "salesAnim.tagSLA": "SLA",
 "salesAnim.tagStd": "มาตรฐานการบริการ",
 "salesAnim.quoteTitle": "ใบเสนอราคา",
 "salesAnim.rowBase": "ค่าบริการพื้นฐาน",
 "salesAnim.rowExtra": "ค่าธรรมเนียมเพิ่มเติม",
 "salesAnim.rowCycle": "รอบการบริการ",
 "salesAnim.rowTerms": "ข้อกำหนด",
 "salesAnim.aiDone": "สร้างโดย AI",
 "salesAnim.manual": "การเสนอราคาด้วยตนเอง",
 "salesAnim.ai": "NovaSales AI",
 "salesAnim.hours": "เฉลี่ยหลายชั่วโมง",
 "salesAnim.minutes": "เพียงไม่กี่นาที",
 "salesAnim.uplift": "ประสิทธิภาพ +90%",
 "salesAnim.checkPrice": "ความสอดคล้องด้านราคา",
 "salesAnim.checkMarket": "สอดรับกับราคาตลาด",
 "salesAnim.checkTerms": "มาตรฐานข้อกำหนด",
 "salesAnim.checkBrand": "สอดคล้องกับแบรนด์",
 "salesAnim.checkRisk": "แจ้งเตือนความเสี่ยงแล้ว",
 "salesAnim.formal": "ใบเสนอราคาอย่างเป็นทางการ",
 "salesAnim.standby": "พร้อมใช้งาน",
 "salesAnim.running": "กำลังสร้าง",
 "salesAnim.complete": "เสร็จสิ้น",
 // Animation texts - Booking Worker
 "bookingAnim.carrierConnected": "เชื่อมต่อแล้ว ",
 "bookingAnim.carriers": "+ สายการเดินเรือและสายการบิน",
 "bookingAnim.responseSpeed": "การตอบสนอง: ",
 "bookingAnim.predictionAccuracy": "ความแม่นยำในการคาดการณ์: ",
 "bookingAnim.todayHandled": "จัดการแล้ววันนี้: ",
 "bookingAnim.times": " ครั้ง",
 "bookingAnim.exceptionResolved": "แก้ไขข้อยกเว้นแล้ว",
 "bookingAnim.apiResponse": "การตอบสนองของ API: 10ms/คำขอ",
 // Animation texts - Customs Worker
 "customsAnim.subtitle": "ระบบอัตโนมัติสำหรับการปฏิบัติตามกฎระเบียบศุลกากรแบบอัจฉริยะ",
 "customsAnim.processComplete": "ดำเนินการเสร็จสิ้น",
 "customsAnim.analyzing": "AI กำลังวิเคราะห์รายละเอียดสินค้า...",
 "customsAnim.product": "สินค้า: Electronic Chip Module",
 "customsAnim.match": "จับคู่",
 "customsAnim.processorController": "ตัวประมวลผลและตัวควบคุม",
 "customsAnim.todaySuggestions": "คำแนะนำวันนี้",
 "customsAnim.screeningEntities": "กำลังคัดกรองรายชื่อนิติบุคคล...",
 "customsAnim.noSanctionRisk": "ไม่มีความเสี่ยงจากการคว่ำบาตร",
 "customsAnim.crossVerified": "การตรวจสอบข้ามผ่านหลายฐานข้อมูลเสร็จสิ้น",
 "customsAnim.todayPassed": "ผ่านการอนุมัติวันนี้",
 "customsAnim.customsRegulations": "กฎระเบียบศุลกากร",
 "customsAnim.import": "นำเข้า",
 "customsAnim.export": "ส่งออก",
 "customsAnim.comprehensiveAnalysis": "การวิเคราะห์การปฏิบัติตามกฎระเบียบแบบครอบคลุม",
 "customsAnim.hsVerify": "การตรวจสอบรหัส HS",
 "customsAnim.sanctionScreen": "การคัดกรองการคว่ำบาตร",
 "customsAnim.regulationMatch": "การจับคู่กฎระเบียบ",
 "customsAnim.riskAssess": "การประเมินความเสี่ยง",
 "customsAnim.reportGenerated": "รายงานการปฏิบัติตามกฎระเบียบถูกสร้างขึ้นแล้ว",
 "customsAnim.autoCheckComplete": "การตรวจสอบอัตโนมัติเสร็จสิ้น",
 "customsAnim.riskLevel": "ระดับความเสี่ยง",
 "customsAnim.low": "ต่ำ",
 "customsAnim.confidence": "ความมั่นใจ",
 "customsAnim.timeTaken": "เวลา",
 "customsAnim.standby": "สแตนด์บาย",
 "customsAnim.completed": "เสร็จสิ้น",
 "customsAnim.processing": "กำลังดำเนินการ",
 "customsAnim.step": "ขั้นตอนที่",
 "customsAnim.monitoring": "การตรวจสอบแบบเรียลไทม์",
 "customsAnim.waitingProcess": "กำลังรอการประมวลผล...",
 // Animation texts - Document Worker
 "docAnim.recognizing": "กำลังจดจำข้อมูล...",
 "docAnim.newTemplates": "เรียนรู้รูปแบบเอกสารใหม่ 2 รูปแบบ",
 "docAnim.anomalyFixed": "ตรวจพบและแก้ไขข้อผิดพลาด 1 รายการ",
 "docAnim.syncing": "กำลังซิงค์ข้อมูล...",
 "docAnim.bl": "B/L",
 "docAnim.productName": "สินค้า: อุปกรณ์อิเล็กทรอนิกส์",
 "docAnim.hsCode": "พิกัดศุลกากร (HS Code): 8471.30",
 "docAnim.weight": "น้ำหนัก: 2,500 กก.",
 "docAnim.pieces": "จำนวน: 150 ชิ้น",
 "docAnim.docCheck": "ตรวจสอบเอกสาร",
 "docAnim.packingQty": "จำนวนบรรจุภัณฑ์:",
 "docAnim.correct": "150 ชิ้น ✓",
 "docAnim.incorrect": "1500 ชิ้น ✗",
 "docAnim.fmsSystem": "ระบบ FMS",
 "docAnim.syncedToFms": "ซิงค์ข้อมูลไปยัง FMS แล้ว",
 "docAnim.templateBl": "B/L",
 "docAnim.templateInvoice": "ใบกำกับสินค้า (Invoice)",
 "docAnim.templatePacking": "รายการบรรจุภัณฑ์ (Packing)",
 "docAnim.templateCustoms": "พิธีการศุลกากร",
 "docAnim.templateOrigin": "ต้นทาง",
 "docAnim.accuracy": "ความแม่นยำในการจดจำข้อมูล:",
 // Social Proof Section
 "socialProof.title": "หลักฐานในรูปแบบดิจิทัล",
 "socialProof.desc": "พันธมิตรทางเทคโนโลยีที่ได้รับความไว้วางใจ",
 "socialProof.stat1": "ผู้ให้บริการขนส่งสินค้า (Freight Forwarder) ไว้วางใจเรา",
 "socialProof.stat2": "ติดตั้งใช้งานได้อย่างรวดเร็ว",
 "socialProof.stat2Unit": "เดือน",
 "socialProof.stat3": "โครงสร้างสถาปัตยกรรมแบบ Native",
 "socialProof.stat4": "ผู้นำในภูมิภาคเอเชียตะวันออกเฉียงใต้",
 "socialProof.certs": "ใบรับรองมาตรฐาน",
 "socialProof.testimonial1.quote": "CargoNova ปฏิวัติการจัดการอัตราค่าระวางของเราอย่างสิ้นเชิง สิ่งที่เคยต้องใช้เวลาหลายชั่วโมง ตอนนี้ใช้เวลาเพียงไม่กี่วินาที แถมยังมีความแม่นยำสูงขึ้นอีกด้วย",
 "socialProof.testimonial1.avatar": "O",
 "socialProof.testimonial1.name": "ผู้อำนวยการฝ่ายปฏิบัติการ",
 "socialProof.testimonial1.company": "Global Logistics Group",
 "socialProof.testimonial2.quote": "แรงงานดิจิทัล (Digital Workers) ช่วยจัดการเอกสารของเราตลอดทั้งคืน ทำให้เราเริ่มต้นวันใหม่ด้วยการจัดส่งสินค้าที่เรียบร้อย แทนที่จะเป็นกองเอกสารที่ทับถมกัน",
 "socialProof.testimonial2.avatar": "C",
 "socialProof.testimonial2.name": "ประธานเจ้าหน้าที่บริหาร (CEO)",
 "socialProof.testimonial2.company": "Pacific Freight Solutions",
 // Shipping Operations Section
 "shipping.title": "ศูนย์ปฏิบัติการการขนส่งสินค้าอัจฉริยะ",
 "shipping.desc": "แพลตฟอร์มการจัดการการขนส่งสินค้าทางเรือและทางอากาศแบบครบวงจร ขับเคลื่อนระบบโลจิสติกส์ด้วย AI",
 "shipping.crm.header.customer": "ลูกค้า",
 "shipping.crm.header.company": "บริษัท",
 "shipping.crm.header.status": "สถานะ",
 "shipping.crm.header.stage": "ขั้นตอน",
 "shipping.crm.customer1": "Michael Li",
 "shipping.crm.company1": "Huawei Tech",
 "shipping.crm.status1": "ลูกค้า VIP",
 "shipping.crm.stage1": "อยู่ระหว่างการขนส่ง",
 "shipping.crm.customer2": "Frank Wang",
 "shipping.crm.company2": "Alibaba",
 "shipping.crm.status2": "ระยะยาว",
 "shipping.crm.stage2": "กำลังจองการขนส่งทางทะเล",
 "shipping.crm.customer3": "David Zhang",
 "shipping.crm.company3": "Tencent",
 "shipping.crm.status3": "ลูกค้าใหม่",
 "shipping.crm.stage3": "รอนำเสนอราคาอากาศ",
 "shipping.crm.customer4": "Steven Chen",
 "shipping.crm.company4": "BYD",
 "shipping.crm.status4": "ลูกค้า VIP",
 "shipping.crm.stage4": "จัดส่งสำเร็จแล้ว",
 "shipping.crm.title": "CRM การขนส่งสินค้า",
 "shipping.crm.desc": "จัดการลูกค้าและคำสั่งซื้อค่าระวางเรือทางทะเล/ทางอากาศในระบบรวมศูนย์พร้อมการติดตามผลอัจฉริยะ",
 "shipping.worker.sea": "Ocean AI Agent",
 "shipping.worker.seaRole": "ตัวแทนการจอง",
 "shipping.worker.air": "Air AI Agent",
 "shipping.worker.airRole": "ผู้ตรวจสอบเอกสาร",
 "shipping.worker.doc": "Document AI Agent",
 "shipping.worker.docRole": "ผู้ช่วยบริการ",
 "shipping.worker.title": "การจัดการ AI Agent",
 "shipping.worker.desc": "กำหนดบทบาทของ AI agent สำหรับสถานการณ์ต่างๆ (การจอง/เอกสาร/การตรวจสอบ) พร้อมการทำงานร่วมกันแบบเรียลไทม์",
 "shipping.resource.20ft": "ตู้คอนเทนเนอร์ขนาด 20 ฟุต",
 "shipping.resource.40ft": "ตู้คอนเทนเนอร์ขนาด 40 ฟุต",
 "shipping.resource.title": "การจองทรัพยากร",
 "shipping.resource.desc": "จองพื้นที่ระวางสินค้าทางทะเล/ทางอากาศ และตู้คอนเทนเนอร์เย็นตามเส้นทางต่างๆ พร้อมแสดงพื้นที่ว่างแบบเรียลไทม์",
 "shipping.scan.billTitle": "ใบตราส่งสินค้า",
 "shipping.scan.origin": "ต้นทาง: เซี่ยงไฮ้",
 "shipping.scan.dest": "ปลายทาง: ลอสแอนเจลิส",
 "shipping.scan.title": "สแกนเอกสารด้วย AI",
 "shipping.scan.desc": "สแกน B/L, AWB, รายการบรรจุภัณฑ์ ผ่านมือถือ ระบบรู้จำข้อมูลสำคัญโดยอัตโนมัติและซิงค์ข้อมูลไปยังระบบ",
 "shipping.fee.title": "รายละเอียดค่าธรรมเนียม",
 "shipping.fee.verified": "ตรวจสอบแล้ว",
 "shipping.fee.port": "ค่าภาระท่าเรือ",
 "shipping.fee.insurance": "ประกันภัย",
 "shipping.fee.transport": "ค่าระวางสินค้า",
 "shipping.fee.total": "ยอดรวม",
 "shipping.fee.linked": "ใบสั่งซื้อเชื่อมโยงอัตโนมัติ",
 "shipping.fee.cardTitle": "การสรุปยอดค่าใช้จ่ายด้วย AI",
 "shipping.fee.cardDesc": "อัปโหลดใบแจ้งหนี้การขนส่งแบบเรียลไทม์ AI จะรับรู้และจัดหมวดหมู่ค่าธรรมเนียมโดยอัตโนมัติเพื่อออกบิลสรุปยอด",
 // AI Tech Section
 "ai.badge": "เทคโนโลยีหลัก · ขีดความสามารถของ AI มากกว่า 60%",
 "ai.title1": "ขับเคลื่อนด้วย AI",
 "ai.title2": "ระบบโลจิสติกส์อัจฉริยะ",
 "ai.subtitle": "สี่ขีดความสามารถหลักของ CargoNova AI ในการสร้างโครงสร้างพื้นฐานโลจิสติกส์อัจฉริยะยุคใหม่",
 "ai.native.title": "สถาปัตยกรรม AI Native",
 "ai.native.subtitle": "ขับเคลื่อนด้วย Native AI",
 "ai.native.desc": "ตั้งแต่โครงสร้างพื้นฐานไปจนถึง UX ได้รับการออกแบบให้เป็น AI-native อย่างสมบูรณ์แบบ ทั้งการตัดสินใจอัจฉริยะ การวิเคราะห์เชิงคาดการณ์ และการเรียนรู้แบบปรับตัว",
 "ai.native.h1": "ระบบการเรียนรู้เชิงลึก",
 "ai.native.h2": "การเพิ่มประสิทธิภาพแบบเรียลไทม์",
 "ai.native.h3": "ภาษาธรรมชาติ",
 "ai.native.h4": "การวิเคราะห์เชิงคาดการณ์",
 "ai.native.statValue": "99.2%",
 "ai.native.statLabel": "ความแม่นยำในการตัดสินใจ",
 "ai.worker.title": "AI Agents",
 "ai.worker.subtitle": "AI Agents",
 "ai.worker.desc": "AI agents อัจฉริยะทำงานตลอด 24 ชั่วโมงทุกวัน จัดการพิธีการศุลกากร การจอง และการติดตามสถานะโดยอัตโนมัติ ช่วยลดภาระงานเพื่อให้พนักงานไปโฟกัสกับงานที่มีมูลค่าสูง",
 "ai.worker.h1": "ศุลกากรระบบออโต้",
 "ai.worker.h2": "การจองอัจฉริยะ",
 "ai.worker.h3": "การจัดการข้อยกเว้น/ข้อผิดพลาด",
 "ai.worker.h4": "ฝ่ายบริการลูกค้า",
 "ai.worker.statValue": "85%",
 "ai.worker.statLabel": "ประหยัดแรงงาน",
 "ai.rpa.title": "ระบบอัตโนมัติ RPA",
 "ai.rpa.subtitle": "หุ่นยนต์จัดการกระบวนการอัตโนมัติ",
 "ai.rpa.desc": "กระบวนการทำงานอัตโนมัติแบบครบวงจร ตั้งแต่การป้อนข้อมูลไปจนถึงการรายงาน ตลอดจนการผสานรวมระบบไปจนถึงการจัดการอีเมล",
 "ai.rpa.h1": "การผสานรวมหลายระบบ",
 "ai.rpa.h2": "การซิงค์ข้อมูลอัตโนมัติ",
 "ai.rpa.h3": "เวิร์กโฟลว์อัจฉริยะ",
 "ai.rpa.h4": "การแจ้งเตือนเมื่อเกิดข้อผิดพลาด",
 "ai.rpa.statValue": "10 เท่า",
 "ai.rpa.statLabel": "เพิ่มประสิทธิภาพ",
 "ai.ocr.title": "Smart OCR",
 "ai.ocr.subtitle": "การจดจำเอกสารอัจฉริยะ",
 "ai.ocr.desc": "เทคโนโลยี OCR แบบเรียนรู้เชิงลึก สามารถจดจำใบตราส่งสินค้า (B/L) ใบแจ้งหนี้ และใบรายการบรรจุหีบห่อได้ทันทีด้วยความแม่นยำกว่า 99%",
 "ai.ocr.h1": "รองรับหลายภาษา",
 "ai.ocr.h2": "การดึงข้อมูลตาราง",
 "ai.ocr.h3": "การตรวจจับลายมือเขียน",
 "ai.ocr.h4": "ระบบจัดหมวดหมู่อัจฉริยะ",
 "ai.ocr.statValue": "99.5%",
 "ai.ocr.statLabel": "ความแม่นยำในการจดจำและประมวลผลข้อมูล",
 "ai.learnMore": "เรียนรู้เพิ่มเติม",
 "ai.cta": "พร้อมสัมผัสประสบการณ์โลจิสติกส์ยุคใหม่ด้วยพลัง AI แล้วหรือยัง?",
 "ai.ctaBtn": "ขอรับการสาธิต",
 // AI Architecture Card
 "ai.arch.badge": "โครงสร้างสถาปัตยกรรมแบบ AI Native",
 "ai.arch.title": "ระบบการตัดสินใจอัจฉริยะ",
 "ai.arch.layer1": "เลเยอร์ธุรกิจ",
 "ai.arch.layer1Sub": "แอปพลิเคชันทางธุรกิจ",
 "ai.arch.layer1.i1": "การสอบถามอัตราค่าระวาง",
 "ai.arch.layer1.i2": "การจัดการการจอง",
 "ai.arch.layer1.i3": "การติดตามสถานะ",
 "ai.arch.layer1.i4": "การเรียกเก็บเงิน",
 "ai.arch.layer2": "เลเยอร์การทำงาน",
 "ai.arch.layer2Sub": "AI Agent",
 "ai.arch.layer2.i1": "การรับส่งและจัดลำดับงาน",
 "ai.arch.layer2.i2": "ระบบอัตโนมัติของกระบวนการทำงาน",
 "ai.arch.layer2.i3": "การจัดการกรณีขัดข้อง",
 "ai.arch.layer2.i4": "การจัดตารางเวลาอัจฉริยะ",
 "ai.arch.layer3": "โครงสร้างพื้นฐาน AI",
 "ai.arch.layer3Sub": "โครงสร้างพื้นฐาน AI",
 "ai.arch.layer3.i1": "LLM",
 "ai.arch.layer3.i2": "เครื่องยนต์ OCR",
 "ai.arch.layer3.i3": "การเรียนรู้ของเครื่อง",
 "ai.arch.layer3.i4": "กราฟความรู้",
 "ai.arch.dataFlow": "การไหลของข้อมูลแบบเรียลไทม์",
 // Digital Employee Card
 "ai.emp.title": "พนักงานดิจิทัล",
 "ai.emp.status": "พร้อมใช้งานออนไลน์",
 "ai.emp.booking": "กระบวนการจอง",
 "ai.emp.bookingBubble": "จับคู่พื้นที่ระวางโดยอัตโนมัติ",
 "ai.emp.bookingStats": "ยอดการจองวันนี้: ",
 "ai.emp.doc": "การตรวจสอบเอกสาร",
 "ai.emp.docBubble": "กำลังดำเนินการจดจำและประมวลผลอัจฉริยะ...",
 "ai.emp.ocrRate": "ความแม่นยำของ OCR 99.2%",
 // RPA Card
 "ai.rpaCard.title": "ระบบอัตโนมัติของกระบวนการทำงาน",
 "ai.rpaCard.pipeline": "RPA Pipeline",
 "ai.rpaCard.bill": "การป้อนข้อมูลใบตราส่งสินค้า (B/L)",
 "ai.rpaCard.billBubble": "เสร็จสิ้นกระบวนการ OCR",
 "ai.rpaCard.billDone": " ถูกป้อนข้อมูลแล้ว",
 "ai.rpaCard.cabin": "Carrier Space Sync",
 "ai.rpaCard.cabinBubble": "ล็อคพื้นที่แล้ว",
 "ai.rpaCard.cabinDone": " ล็อคแล้ว",
 "ai.rpaCard.fee": "ตรวจสอบค่าธรรมเนียมท่าเรือ",
 "ai.rpaCard.feeBubble": "ส่งไปยังการชำระเงินแล้ว",
 "ai.rpaCard.feeDone": "ส่งไปยังการชำระเงินแล้ว",
 "ai.rpaCard.complete": "กระบวนการ RPA เสร็จสิ้น",
 "ai.rpaCard.running": "ระบบอัตโนมัติกำลังทำงาน...",
 "ai.rpaCard.order": "คำสั่งซื้อ",
 "ai.rpaCard.misc": "ค่าธรรมเนียม",
 "ai.rpaCard.diff": "ส่วนต่าง: 0",
 "ai.rpaCard.locked": "ล็อคพื้นที่แล้ว",
 "ai.rpaCard.entered": "ป้อนแล้ว: ",
 "ai.rpaCard.tickets": " ตั๋ว",
 // OCR Card
 "ai.ocrCard.title": "การรู้จำเอกสาร (Document Recognition)",
 "ai.ocrCard.system": "ระบบการจอง (Booking System)",
 "ai.ocrCard.upload": "ลาก / คลิก เพื่ออัปโหลดเอกสาร",
 "ai.ocrCard.uploadSub": "(B/L / Packing List)",
 "ai.ocrCard.file": "Bill_of_Lading.pdf",
 "ai.ocrCard.structure": "ข้อมูลที่มีโครงสร้าง",
 "ai.ocrCard.synced": "ซิงค์กับโมดูลการจองแล้ว",
 "ai.ocrCard.extracted": "สกัดข้อมูลแล้ว",
 "ai.ocrCard.archived": "เก็บถาวรแล้ว",
 "ai.ocrCard.accuracy": "ความแม่นยำในการรู้จำ: ",
 "ai.ocrCard.field1": "ชื่อสินค้า",
 "ai.ocrCard.field1Val": "Electronics",
 "ai.ocrCard.field2": "พิกัดศุลกากร (HS Code)",
 "ai.ocrCard.field2Val": "8542.31.00",
 "ai.ocrCard.field3": "น้ำหนักรวม (Gross Weight)",
 "ai.ocrCard.field3Val": "2,450 KG",
 "ai.ocrCard.field4": "ท่าเรือปลายทาง",
 "ai.ocrCard.field4Val": "Rotterdam",
 "ai.ocrCard.wait": "กำลังรอเอกสาร...",
 "ai.ocrCard.loading": "กำลังโหลดเอกสาร...",
 "ai.ocrCard.recognizing": "OCR กำลังอ่านข้อมูล...",
 "ai.ocrCard.extracting": "กำลังดึงข้อมูล...",
 "ai.ocrCard.syncing": "กำลังซิงค์ข้อมูล...",
 "ai.ocrCard.complete": "การรู้จำเสร็จสมบูรณ์",
 // Partners Section
 "partners.badge": "พันธมิตร",
 "partners.title": "พันธมิตร",
 "partners.desc": "พันธมิตรที่แน่นแฟ้นกับสายการเดินเรือ สายการบิน และบริษัทเทคโนโลยีชั้นนำระดับโลก เพื่อการให้บริการโลจิสติกส์ระดับพรีเมียม",
 "partners.shipping": "พันธมิตรสายการเดินเรือ",
 "partners.air": "พันธมิตรสายการบิน",
 "partners.ports": "ท่าเรือที่ครอบคลุม",
 "partners.countries": "ประเทศ/ภูมิภาค",
 // About Section
 "about.badge": "เกี่ยวกับเรา",
 "about.title1": "บุกเบิก ",
 "about.title2": "ยุคใหม่",
 "about.title3": " แห่งระบบโลจิสติกส์อัจฉริยะ",
 "about.imgAlt": "การทำงานร่วมกันของทีมงานมืออาชีพด้านโลจิสติกส์อัจฉริยะ",
 "about.p1": "CargoNova คือแพลตฟอร์มผู้รับจัดการขนส่งสินค้าแบบ AI-native โดย Deep Insights (สิงคโปร์) นำเสนอโซลูชันการจัดการขนส่งสินค้าดิจิทัลสำหรับผู้ขนส่งสินค้าทั้งทางอากาศ ทางทะเล และการขนส่งต่อเนื่องหลายรูปแบบ ในฐานะแบรนด์ย่อยอัจฉริยะของ Deep Insights แพลตฟอร์มนี้ได้ผสานรวมเทคโนโลยีล้ำสมัย รวมถึง Large Language Models (LLM), ระบบอัตโนมัติ RPA และ OCR อัจฉริยะ เพื่อนำเสนอ AI Agent Matrix ปฏิวัติวงการที่ครอบคลุม 7 โมดูลหลัก ได้แก่ การจัดการอัตราค่าระวาง, การเสนอราคาอัจฉริยะ, การจัดการการจองระวาง, การประมวลผลเอกสาร, การจัดการพิธีการศุลกากร, การตรวจสอบยอดเงิน และการบริหารความเสี่ยง ด้วยความมุ่งมั่นในพันธกิจที่จะ 'ทำให้ทุกการขนส่งดำเนินงานได้อย่างอัจฉริยะ' CargoNova สนับสนุนการใช้งานทั่วโลกในหลากหลายภาษา หลายสกุลเงิน และหลายระเบียบข้อบังคับผ่านสถาปัตยกรรมแบบ Cloud-native ช่วยให้ผู้รับจัดการขนส่งสินค้าสามารถบรรลุ SLA อัตราค่าระวางที่ 99.5%, อัตราความสำเร็จในการจองระวางที่ 98.2% และความถูกต้องแม่นยำของเอกสารที่ 99.8%",
 "about.p1Link": "https://en.deepinsights.com.cn/",
 "about.p2": "",
 "about.learnMoreDongyin": "เรียนรู้เพิ่มเติมเกี่ยวกับ Deep Insights →",
 "about.stat1": "ก่อตั้งเมื่อ",
 "about.stat2": "สมาชิกในทีม",
 "about.stat3": "รอบการระดมทุน",
 "about.mission": "พันธกิจ",
 "about.missionDesc": "ปรับโฉมโลจิสติกส์ระดับโลกด้วยเทคโนโลยี AI เพื่อให้ทุกการขนส่งมีความชาญฉลาดและมีประสิทธิภาพยิ่งขึ้น",
 "about.vision": "วิสัยทัศน์",
 "about.visionDesc": "ก้าวสู่การเป็นแพลตฟอร์มโลจิสติกส์อัจฉริยะแบบ AI Native ชั้นนำของโลก เชื่อมต่อทุกมุมโลกเข้าด้วยกัน",
 "about.values": "ค่านิยม",
 "about.valuesDesc": "ขับเคลื่อนด้วยนวัตกรรม, ลูกค้าต้องมาก่อน, ความซื่อสัตย์สุจริต และการมุ่งสู่ความเป็นเลิศ",
 "about.team": "ทีมงาน",
 "about.teamDesc": "รวบรวมบุคลากรชั้นนำจากภาคส่วน AI โลจิสติกส์ และเทคโนโลยี เพื่อสร้างทีมงานนวัตกรรมข้ามสายงาน",
 "about.companyIntro": "ภาพรวมบริษัท",
 "about.coreValues": "ค่านิยมหลัก",
 "about.highlight1Title": "แพลตฟอร์มคลาวด์แบบครบวงจร",
 "about.highlight1Desc": "5 ผลิตภัณฑ์คลาวด์แบบครบวงจร ได้แก่ OMS, TMS, WMS, YMS, GTM",
 "about.highlight2Title": "การขับเคลื่อนอุตสาหกรรมสู่ระบบดิจิทัล",
 "about.highlight2Desc": "3 กลุ่มผลิตภัณฑ์ดิจิทัลสำหรับการขนส่งทางเรือ การรับจัดการขนส่งสินค้า และโลจิสติกส์แบบครบวงจร",
 "about.highlight3Title": "ผลิตภัณฑ์ AI อัจฉริยะ",
 "about.highlight3Desc": "ผลิตภัณฑ์ซัพพลายเชนอัจฉริยะ DI.AI โดย CargoNova ให้บริการโซลูชันแบบ AI Native, AI Agents ที่ผสานรวมอัลกอริทึม OR เข้ากับ LLM",
 "about.highlight4Title": "การยอมรับจากลูกค้าระดับชั้นนำ",
 "about.highlight4Desc": "DHL, Sinotrans, Honour Lane Shipping, KORMAN INTERNATIONAL (สิงคโปร์, ฮ่องกง, อินโดนีเซีย)",
 "about.companyData.title": "ข้อมูลบริษัท",
 "about.companyData.parentLabel": "บริษัทแม่",
 "about.companyData.parentValue": "Deep Insights (洞隐科技)",
 "about.companyData.hqLabel": "สำนักงานใหญ่",
 "about.companyData.hqValue": "สิงคโปร์ (Marina Bay Financial Centre)",
 "about.companyData.productLabel": "สายผลิตภัณฑ์หลัก",
 "about.companyData.productValue": "WMS Cloud, TMS Cloud, CargoNova",
 "about.ourNumbers.title": "ตัวเลขของเรา",
 "about.ourNumbers.stat1Label": "ผู้ให้บริการขนส่งสินค้าที่ให้บริการ",
 "about.ourNumbers.stat1Value": "600+",
 "about.ourNumbers.stat2Label": "ประเทศและภูมิภาค",
 "about.ourNumbers.stat2Value": "30+",
 "about.ourNumbers.stat3Label": "อัตราการจัดส่งตรงเวลา",
 "about.ourNumbers.stat3Value": "99.5%",
 "about.parentCompanyText": "CargoNova เป็นส่วนหนึ่งของชุดผลิตภัณฑ์ Deep Insights ร่วมกับ WMS Cloud และ TMS Cloud",
 "about.lastUpdated": "อัปเดตล่าสุด: มิถุนายน 2026",
 "about.timeline": "ประวัติการพัฒนา",
 "about.milestone2003_1": "ก่อตั้ง Quantum Asia & Gillion Software",
 "about.milestone2003_2": "การติดตั้งระบบซอฟต์แวร์ ERP",
 "about.milestone2003_3": "พัฒนาซอฟต์แวร์ SCM สำหรับองค์กรโลจิสติกส์ขนาดใหญ่",
 "about.milestone2008_1": "มุ่งเน้นที่ซอฟต์แวร์การทำงานด้านซัพพลายเชน",
 "about.milestone2008_2": "ได้รับการจดทะเบียนใน Shanghai Hi-Tech Enterprise",
 "about.milestone2008_3": "ได้รับการยอมรับในฐานะ Shanghai Key Software Enterprise",
 "about.milestone2014_1": "ได้รับรางวัล National Hi-Tech Zone Top 100 Enterprise",
 "about.milestone2014_2": "ปรับปรุงผลิตภัณฑ์ SCM ใหม่ด้วยสถาปัตยกรรมคลาวด์และหน่วยบริการย่อย (microservices)",
 "about.milestone2016_1": "Gillion Software เสร็จสิ้นการระดมทุนใน Zhangjiang Century",
 "about.milestone2016_2": "Tuofeng เข้าซื้อหุ้นของ Zhangjiang Century",
 "about.milestone2016_3": "Quantum Asia ได้รับการลงทุนเชิงกลยุทธ์จาก Yonyou",
 "about.milestone2019_1": "เป็นพันธมิตรกับ HUST พัฒนาผลิตภัณฑ์ซัพพลายเชนที่มีประสิทธิภาพสูงสุดโดยใช้ข้อมูลและ AI",
 "about.milestone2019_2": "ได้รับการจัดอันดับในรายงาน TMS & WMS ของ Gartner",
 "about.milestone2019_3": "เพิ่มประสิทธิภาพการทำงานของแอปพลิเคชันแพลตฟอร์มบริการระดับกลาง (service middle platform)",
 "about.milestone2022_1": "ก่อตั้ง Deep Insights และเสร็จสิ้นการระดมทุนระดับ Series A จาก Yinshan Capital",
 "about.newStat1": "ปีแห่งประสบการณ์ในการทำระบบ SCM Digitalization",
 "about.newStat2": "จำนวนการเข้าใช้งานของลูกค้า",
 "about.newStat3": "AI Agents",
 "about.newStat4": "สมาชิกทีมวิจัยและพัฒนาหลัก",
 "about.newStat5": "ลูกค้าองค์กร",
 "about.newStat6": "ผู้ใช้งานระบบจริงต่อวัน (Daily Active Users)",
 // Contact Section
 "contact.badge": "ติดต่อเรา",
 "contact.title": "พร้อมที่จะปฏิรูปธุรกิจขนส่งสินค้าของคุณแล้วหรือยัง?",
 "contact.desc": "เข้าร่วมกับผู้ให้บริการขนส่งสินค้าชั้นนำที่กำหนดใช้เมทริกซ์ AI agent แล้ววันนี้",
 "contact.help": "ต้องการความช่วยเหลือ?",
 "contact.helpDesc": "ผู้ช่วย AI และทีมงานมืออาชีพของเราพร้อมตอบคำถามของคุณตลอด 24 ชั่วโมง",
 "contact.chat": "แชทสด",
 "contact.phone": "โทรศัพท์",
 "contact.email": "อีเมล",
 "contact.address": "ที่อยู่",
 "contact.addressVal": "Lujiazui Financial Center, Pudong, Shanghai",
 "contact.hours": "เวลาทำการ",
 "contact.hoursVal": "จันทร์-ศุกร์ 9:00-18:00 น.",
 "contact.formTitle": "ส่งข้อความ",
 "contact.name": "ชื่อ",
 "contact.namePh": "ชื่อของคุณ",
 "contact.company": "บริษัท",
 "contact.companyPh": "ชื่อบริษัท",
 "contact.emailPh": "your@email.com",
 "contact.phonePh": "เบอร์โทรศัพท์",
 "contact.message": "ข้อความ",
 "contact.messagePh": "อธิบายความต้องการของคุณ...",
 "contact.send": "ส่งข้อความ",
 // CTA
 "cta.demo": "จองเดโม",
 "cta.download": "ดาวน์โหลดโบรชัวร์",
 // Solutions Page
 "solutions.title": "โซลูชัน",
 "solutions.subtitle": "ระบบและแพลตฟอร์ม freight forwarder ที่ปรับแต่งมาเพื่อผู้ให้บริการขนส่งสินค้าแต่ละประเภท",
 "solutions.painPointsTitle": "ปัญหาหลัก",
 "solutions.painPointsSubtitle": "ความท้าทายทางธุรกิจทั่วไป",
 "solutions.solutionsTitle": "CargoNova ช่วยแก้ไขอย่างไร",
 "solutions.solutionsSubtitle": "โซลูชันอัจฉริยะจาก CargoNova",
 "solutions.solutionsBadge": "โซลูชันอัจฉริยะ",
 "solutions.improvementsTitle": "ผลลัพธ์ที่คาดว่าจะดีขึ้น",
 "solutions.whySuitable": "ทำไมสิ่งนี้ถึงเหมาะกับคุณ",
 "solutions.ctaDiagnosis": "ขอรับการวิเคราะห์ฟรี",
 "solutions.tab1.label": "สำหรับผู้ขนส่งสินค้าท้องถิ่นในเอเชียตะวันออกเฉียงใต้",
 "solutions.tab1.hero": "ต้องการเป็นผู้นำในการแข่งขันด้านดิจิทัลในฐานะผู้ขนส่งสินค้าในเอเชียตะวันออกเฉียงใต้หรือไม่?",
 "solutions.tab1.heroSub": "CargoNova คือแพลตฟอร์ม ERP ที่ออกแบบมาเพื่อคุณโดยเฉพาะ",
 "solutions.tab1.pain1": "ระบบซับซ้อนเกินไป ต้นทุนการฝึกอบรมพนักงานสูง",
 "solutions.tab1.pain2": "คู่แข่งก้าวสู่ระบบดิจิทัล แต่เรายังคงติดอยู่กับการใช้ Excel",
 "solutions.tab1.pain3": "กฎระเบียบข้อบังคับในเอเชียตะวันออกเฉียงใต้มีความซับซ้อนและเกิดข้อผิดพลาดได้ง่าย",
 "solutions.tab1.sol1": "อินเทอร์เฟซที่ปรับให้เข้ากับท้องถิ่นเอเชียตะวันออกเฉียงใต้อย่างสมบูรณ์ ใช้งานง่ายเหมือน WeChat",
 "solutions.tab1.sol2": "ระบบ e-Customs สำหรับเอเชียตะวันออกเฉียงใต้ในตัว จัดการด้านกฎระเบียบโดยอัตโนมัติ",
 "solutions.tab1.sol3": "มี AI Agent 7 ตัวช่วยเสนอราคา จองพื้นที่ระวาง และตรวจสอบกระทบยอดให้โดยอัตโนมัติ",
 "solutions.tab1.imp1": "ประสิทธิภาพการดำเนินงาน",
 "solutions.tab1.imp2": "การเปิดใช้งานระบบ",
 "solutions.tab1.imp3": "อัตราการลาออกของพนักงาน",
 "solutions.tab1.impVal1": "↑ 300%",
 "solutions.tab1.impVal2": "3 วัน",
 "solutions.tab1.impVal3": "↓ 50%",
 "solutions.tab1.why": "เราได้รับการออกแบบมาเพื่อธุรกิจท้องถิ่นในเอเชียตะวันออกเฉียงใต้ โดยเข้าใจปัญหาและกระบวนการทำงานของคุณอย่างถ่องแท้",
 "solutions.tab2.label": "สำหรับวิสาหกิจจีนในต่างประเทศ",
 "solutions.tab2.hero": "กำลังขยายธุรกิจไปทั่วโลกแต่ข้อมูลสาขากลับสับสนวุ่นวายใช่ไหม?",
 "solutions.tab2.heroSub": "CargoNova คือแพลตฟอร์มการจัดการแบบรวมศูนย์ระดับโลกของคุณ",
 "solutions.tab2.pain1": "สำนักงานใหญ่ไม่สามารถเห็นการดำเนินงานของสาขาต่างประเทศได้อย่างชัดเจน",
 "solutions.tab2.pain2": "ข้อมูลสาขาไม่เคยกระทบยอดได้ตรงกัน",
 "solutions.tab2.pain3": "ขั้นตอนการรายงานที่ซับซ้อน ทำให้ตัดสินใจได้ล่าช้า",
 "solutions.tab2.sol1": "สำนักงานใหญ่เห็นข้อมูลของทุกสาขาได้แบบเรียลไทม์",
 "solutions.tab2.sol2": "ระบบเดียว รองรับหลายประเทศ พร้อมอินเทอร์เฟซสลับอัตโนมัติ",
 "solutions.tab2.sol3": "ยืดหยุ่นสำหรับผู้ปฏิบัติงานหน้างาน ควบคุมได้ง่ายสำหรับสำนักงานใหญ่",
 "solutions.tab2.imp1": "การเติบโตทางธุรกิจ",
 "solutions.tab2.imp2": "ต้นทุนแรงงานที่เพิ่มขึ้น",
 "solutions.tab2.imp3": "รอบระยะเวลาการกระทบยอด",
 "solutions.tab2.impVal1": "2-3 เท่า",
 "solutions.tab2.impVal2": "< 20%",
 "solutions.tab2.impVal3": "↓ 85%",
 "solutions.tab2.why": "AI Agent ทั้ง 7 ของเราช่วยให้คุณผสานรวมการบริหารจัดการสาขาทั่วโลกและกำจัดปัญหาคลังข้อมูลที่แยกส่วนกัน",
 "solutions.tab3.label": "สำหรับผู้ให้บริการขนส่งสินค้าทั่วโลก",
 "solutions.tab3.hero": "ธุรกิจเติบโตอย่างรวดเร็วแต่แรงกดดันด้านต้นทุนกลับเพิ่มขึ้นใช่ไหม?",
 "solutions.tab3.heroSub": "CargoNova ช่วยให้คุณทำงานได้เพิ่มขึ้น 3 เท่าด้วยจำนวนพนักงานเพียงครึ่งเดียว",
 "solutions.tab3.pain1": "ธุรกิจโตเป็นเท่าตัวหมายถึงต้องจ้างงานเพิ่มขึ้นเท่าตัว ส่งผลให้กำไรหดหาย",
 "solutions.tab3.pain2": "คอขวดของระบบและต้นทุนแรงงานฉุดรั้งธุรกิจไปพร้อมกัน",
 "solutions.tab3.pain3": "ต้องการโซลูชันดิจิทัลที่รวดเร็วและมีเสถียรภาพ",
 "solutions.tab3.sol1": "ให้ทีมงาน 60 คนของคุณทำงานได้เทียบเท่ากับทีมงาน 150 คน",
 "solutions.tab3.sol2": "เพิ่มอัตรากำไรโดยตรง (ลดต้นทุนเงินเดือนจาก 40% → 15%)",
 "solutions.tab3.sol3": "ติดตั้งใช้งานรวดเร็ว (3 เดือน) เห็นผลลัพธ์ได้ทันที",
 "solutions.tab3.imp1": "ประสิทธิภาพ",
 "solutions.tab3.imp2": "อัตรากำไร",
 "solutions.tab3.imp3": "ระยะเวลาเริ่มใช้งานจริง",
 "solutions.tab3.impVal1": "↑ 250%",
 "solutions.tab3.impVal2": "↑ 13%",
 "solutions.tab3.impVal3": "3 เดือน",
 "solutions.tab3.why": "ความสามารถในการติดตั้งใช้งานที่รวดเร็วของเราช่วยแก้ปัญหา 'เติบโตอย่างรวดเร็วในขณะที่ยังควบคุมต้นทุนได้' ของคุณ",
 // Customers Page
 "customers.pageTitle": "เรื่องราวนำความสำเร็จของลูกค้า",
    "customers.pageSubtitle": "ดูว่าผู้ให้บริการขนส่งสินค้าเปลี่ยนแปลงธุรกิจด้วย CargoNova อย่างไร",
    "customers.caseStudiesHeading": "เรื่องราวความสำเร็จของลูกค้า",
 "customers.metricsTitle": "ตัวชี้วัดความสำเร็จของลูกค้า",
 "customers.metric1": "บริษัทที่ไว้วางใจเรา",
 "customers.metric2": "จำนวนเดือนในการเริ่มใช้งานจริง",
 "customers.metric3": "เพิ่มประสิทธิภาพในการทำงาน",
 "customers.metric4": "การปฏิบัติงานอย่างต่อเนื่อง",
 "customers.challengeLabel": "ความท้าทาย",
 "customers.solutionLabel": "แนวทางแก้ไข",
 "customers.resultsLabel": "ผลลัพธ์",
 "customers.testimonialsTitle": "สิ่งที่ลูกค้าของเรากล่าวถึง",
 "customers.ctaTitle": "พร้อมที่จะเริ่มเขียนเรื่องราวความสำเร็จของคุณแล้วหรือยัง?",
 "customers.ctaSubtitle": "ร่วมเป็นส่วนหนึ่งกับผู้ให้บริการขนส่งสินค้าชั้นนำที่ได้เริ่มใช้งานระบบการทำงานแบบดิจิทัลแล้ว",
 "customers.case1.type": "ผู้ให้บริการขนส่งสินค้าในภูมิภาคเอเชียตะวันออกเฉียงใต้",
 "customers.case1.company": "บริษัทขนส่งสินค้าชั้นนำในเอเชียตะวันออกเฉียงใต้",
 "customers.case1.challenge": "ระบบการทำงานมีความซับซ้อนและมีต้นทุนในการฝึกอบรมสูง ในขณะที่คู่แข่งเปลี่ยนไปใช้ระบบดิจิทัลหมดแล้ว แต่บริษัทยังคงใช้ Excel",
 "customers.case1.solution": "เปิดใช้งาน AI Agent 7 ระบบ, อินเทอร์เฟซรองรับหลายภาษา, พร้อมระบบการปฏิบัติตามกฎระเบียบศุลกากรแบบอิเล็กทรอนิกส์ (e-Customs) ของเอเชียตะวันออกเฉียงใต้ในตัว",
 "customers.case1.result1": "ประสิทธิภาพในการดำเนินงาน",
 "customers.case1.result2": "จำนวนวันในการเริ่มใช้งานจริง",
 "customers.case1.result3": "อัตราการลาออกของพนักงาน",
 "customers.case1.quote": "CargoNova ปรับเปลี่ยนการดำเนินงานของเราให้ดีขึ้นอย่างเห็นได้ชัดในชั่วข้ามคืน อินเทอร์เฟซที่ปรับให้เข้ากับท้องถิ่นทำให้การเริ่มต้นใช้งานเป็นเรื่องง่ายและราบรื่น",
 "customers.case2.type": "บริษัทระดับโลกของจีน",
 "customers.case2.company": "โซลูชันการค้าระดับโลก",
 "customers.case2.challenge": "สำนักงานใหญ่ไม่สามารถติดตามการดำเนินงานของสาขาต่างประเทศได้ และข้อมูลระหว่างสาขาไม่เคยตรงกัน",
 "customers.case2.solution": "แพลตฟอร์มการบริหารจัดการระดับโลกที่เป็นหนึ่งเดียว ช่วยให้สำนักงานใหญ่สามารถมองเห็นการทำงานของทุกสาขาได้แบบเรียลไทม์",
 "customers.case2.result1": "การเติบโตทางธุรกิจ",
 "customers.case2.result2": "อัตราการเพิ่มขึ้นของค่าแรง",
 "customers.case2.result3": "รอบระยะเวลาการตรวจสอบยอดบัญชี",
 "customers.case2.quote": "ในที่สุดเราก็สามารถดูข้อมูลของทุกสาขาได้แบบเรียลไทม์ ช่วยให้การตัดสินใจเกิดขึ้นได้ทันทีและมีประสิทธิภาพมากขึ้น",
 "customers.case3.type": "สำหรับผู้ให้บริการขนส่งสินค้าสากล",
 "customers.case3.company": "พันธมิตรผู้ให้บริการขนส่งสินค้าระดับโลก",
 "customers.case3.challenge": "ธุรกิจเติบโตอย่างรวดเร็วท่ามกลางแรงกดดันด้านต้นทุนที่สูงมาก การขยายธุรกิจเพิ่มขึ้นเท่าตัวหมายถึงการที่ต้องเพิ่มจำนวนพนักงานขึ้นอีกเท่าตัว",
 "customers.case3.solution": "พนักงานดิจิทัลช่วยเพิ่มผลงานของทีมขึ้นถึง 3 เท่า ซึ่งส่งผลดีโดยตรงต่ออัตรากำไร",
 "customers.case3.result1": "ประสิทธิภาพ",
 "customers.case3.result2": "อัตรากำไร",
 "customers.case3.result3": "ระยะเวลาเป็นเดือนในการเริ่มใช้งานจริง",
 "customers.case3.quote": "อัตรากำไรเพิ่มขึ้นจาก 12% เป็น 28% ผลตอบแทนจากการลงทุน (ROI) เกิดขึ้นในทันที",
 "customers.testimonial1.quote": "CargoNova ช่วยพลิกโฉมการบริหารจัดการอัตราค่าบริการของเราอย่างสิ้นเชิง สิ่งที่เคยต้องใช้เวลานานหลายชั่วโมง ขณะนี้เสร็จสิ้นภายในไม่กี่วินาที แถมยังมีความแม่นยำสูงขึ้นอีกด้วย",
 "customers.testimonial1.author": "ผู้อำนวยการฝ่ายปฏิบัติการ",
 "customers.testimonial1.company": "กลุ่มบริษัทโลจิสติกส์ระดับโลก",
 "customers.testimonial2.quote": "พนักงานดิจิทัลจัดการเอกสารของเราตลอดทั้งคืน เมื่อเราตื่นมาก็พบว่าการจัดส่งได้รับการดำเนินงานเรียบร้อยแล้วแทนที่จะต้องเจอกับกองเอกสาร",
 "customers.testimonial2.author": "ซีอีโอ (CEO)",
 "customers.testimonial2.company": "Pacific Freight Solutions",
 // Footer
 "footer.slogan": "แพลตฟอร์มโลจิสติกส์อัจฉริยะแบบ AI Native เชื่อมต่อโลกด้วยเทคโนโลยี",
 "footer.services": "บริการ",
 "footer.services.1": "การขนส่งสินค้าทางทะเล",
 "footer.services.2": "การขนส่งสินค้าทางอากาศ",
 "footer.services.3": "การกำหนดราคาอัจฉริยะ",
 "footer.services.4": "การชำระเงินอัจฉริยะ",
 "footer.tech": "เทคโนโลยี",
 "footer.tech.1": "AI Native",
 "footer.tech.2": "AI Agents",
 "footer.tech.3": "ระบบอัตโนมัติ RPA",
 "footer.tech.4": "OCR อัจฉริยะ",
 "footer.company": "บริษัท",
 "footer.company.1": "เกี่ยวกับเรา",
 "footer.company.2": "พันธมิตร",
 "footer.company.3": "ข่าวสาร",
 "footer.company.4": "ร่วมงานกับเรา",
 "footer.support": "ฝ่ายสนับสนุน",
 "footer.support.1": "ศูนย์ช่วยเหลือ",
 "footer.support.2": "เอกสาร API",
 "footer.support.3": "ติดต่อเรา",
 "footer.support.4": "นโยบายความเป็นส่วนตัว",
 "footer.deepInsightsTagline": "ขับเคลื่อนโดย Deep Insights",
 "footer.copyright": "© 2025-2026 Deep Insights., สงวนลิขสิทธิ์ทั้งหมด",
 "footer.terms": "ข้อกำหนดการให้บริการ",
 "footer.privacy": "นโยบายความเป็นส่วนตัว",
 "footer.cookies": "การตั้งค่าคุกกี้",
 },
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const getLanguageFromPathname = (pathname: string): Language => {
  if (pathname === "/zh" || pathname.startsWith("/zh/")) return "zh";
  if (pathname === "/th" || pathname.startsWith("/th/")) return "th";
  return "en";
};

const stripLanguagePrefix = (pathname: string) => {
  if (pathname === "/zh" || pathname === "/th") return "/";
  if (pathname.startsWith("/zh/") || pathname.startsWith("/th/")) return pathname.slice(3);
  return pathname;
};

export function LanguageProvider({ children }: { children: ReactNode }) {
 const location = useLocation();
 const [language, setLanguageState] = useState<Language>(() => getLanguageFromPathname(location.pathname));

 useEffect(() => {
   setLanguageState(getLanguageFromPathname(location.pathname));
 }, [location.pathname]);

 useEffect(() => {
   const syncLanguageFromUrl = () => {
     setLanguageState(getLanguageFromPathname(window.location.pathname));
   };
   window.addEventListener("popstate", syncLanguageFromUrl);
   return () => window.removeEventListener("popstate", syncLanguageFromUrl);
 }, []);

 const setLanguage = (lang: Language) => {
   const currentPath = window.location.pathname;
   const currentUrl = `${currentPath}${window.location.search}${window.location.hash}`;
   const stripped = stripLanguagePrefix(currentPath);
   const target =
     lang === "en" ? stripped
     : stripped === "/" ? `/${lang}`
     : `/${lang}${stripped}`;
   const targetUrl = `${target}${window.location.search}${window.location.hash}`;

   setLanguageState(lang);
   if (targetUrl !== currentUrl) {
     window.history.pushState(window.history.state, "", targetUrl);
   }
 };

 const t = (key: string): string => {
 const value = translations[language][key];
 return value !== undefined ? value : key;
 };

 return (
 <LanguageContext.Provider value={{ language, setLanguage, t }}>
 {children}
 </LanguageContext.Provider>
 );
}

export function useLanguage() {
 const context = useContext(LanguageContext);
 if (!context) {
 throw new Error("useLanguage must be used within a LanguageProvider");
 }
 return context;
}